/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const searchAppointmentsCustom = /* GraphQL */ `query SearchAppointmentsCustom($input: AppointmentSearchInput!) {
  searchAppointmentsCustom(input: $input) {
    items {
      id
      patient_name
      primary_claim_number
      other_claim_numbers
      doctor_name
      location
      doctor_id
      date
      time
      language
      appt_type
      is_prod
      __typename
    }
    total
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchAppointmentsCustomQueryVariables,
  APITypes.SearchAppointmentsCustomQuery
>;
export const searchAppointmentDocs = /* GraphQL */ `query SearchAppointmentDocs($input: AppointmentDocSearchInput!) {
  searchAppointmentDocs(input: $input) {
    items {
      chunk_id
      uploaded_file_id
      filename
      content
      start_page_number
      end_page_number
      chunk_index
      token_count
      score
      highlights
      __typename
    }
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchAppointmentDocsQueryVariables,
  APITypes.SearchAppointmentDocsQuery
>;
export const searchGeneralDocs = /* GraphQL */ `query SearchGeneralDocs($input: GeneralDocSearchInput!) {
  searchGeneralDocs(input: $input) {
    items {
      chunk_id
      filename
      content
      start_page_number
      end_page_number
      chunk_index
      token_count
      score
      highlights
      __typename
    }
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchGeneralDocsQueryVariables,
  APITypes.SearchGeneralDocsQuery
>;
export const searchDoctors = /* GraphQL */ `query SearchDoctors($input: DoctorSearchInput!) {
  searchDoctors(input: $input) {
    items {
      id
      first_name
      middle_name
      last_name
      npi
      office_phone
      email
      title
      specialties
      work_city
      work_state
      home_state
      physician_partner_id
      doctor_user_id
      license_number
      __typename
    }
    total
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchDoctorsQueryVariables,
  APITypes.SearchDoctorsQuery
>;
export const searchLocations = /* GraphQL */ `query SearchLocations($input: LocationSearchInput!) {
  searchLocations(input: $input) {
    items {
      id
      location_name
      abbreviation
      city
      street
      zip
      state
      region
      status
      __typename
    }
    total
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchLocationsQueryVariables,
  APITypes.SearchLocationsQuery
>;
export const searchInsuranceCarriers = /* GraphQL */ `query SearchInsuranceCarriers($input: InsuranceCarrierSearchInput!) {
  searchInsuranceCarriers(input: $input) {
    items {
      id
      name
      cities
      states
      default_address_id
      default_fax_number_id
      default_phone_number_id
      __typename
    }
    total
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchInsuranceCarriersQueryVariables,
  APITypes.SearchInsuranceCarriersQuery
>;
export const searchLawFirms = /* GraphQL */ `query SearchLawFirms($input: LawFirmSearchInput!) {
  searchLawFirms(input: $input) {
    items {
      id
      name
      law_firm_type
      cities
      states
      default_address_id
      default_fax_number_id
      default_phone_number_id
      __typename
    }
    total
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchLawFirmsQueryVariables,
  APITypes.SearchLawFirmsQuery
>;
export const listAppointmentsOptimized = /* GraphQL */ `query ListAppointmentsOptimized($input: ListAppointmentsOptimizedInput!) {
  listAppointmentsOptimized(input: $input) {
    appointments {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAppointmentsOptimizedQueryVariables,
  APITypes.ListAppointmentsOptimizedQuery
>;
export const batchGetDataFields = /* GraphQL */ `query BatchGetDataFields($ids: [ID!]!) {
  batchGetDataFields(ids: $ids) {
    id
    name
    category
    dataType
    default
    description
    sectionID
    section {
      id
      name
      default
      fields {
        items {
          id
          name
          category
          dataType
          default
          description
          sectionID
          migrationKey
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    migrationKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BatchGetDataFieldsQueryVariables,
  APITypes.BatchGetDataFieldsQuery
>;
export const getAppointmentFileReference = /* GraphQL */ `query GetAppointmentFileReference($id: ID!) {
  getAppointmentFileReference(id: $id) {
    id
    appointmentID
    uploadedFileID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAppointmentFileReferenceQueryVariables,
  APITypes.GetAppointmentFileReferenceQuery
>;
export const listAppointmentFileReferences = /* GraphQL */ `query ListAppointmentFileReferences(
  $filter: ModelAppointmentFileReferenceFilterInput
  $limit: Int
  $nextToken: String
) {
  listAppointmentFileReferences(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAppointmentFileReferencesQueryVariables,
  APITypes.ListAppointmentFileReferencesQuery
>;
export const appointmentFileReferencesByAppointmentID = /* GraphQL */ `query AppointmentFileReferencesByAppointmentID(
  $appointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentFileReferenceFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentFileReferencesByAppointmentID(
    appointmentID: $appointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentFileReferencesByAppointmentIDQueryVariables,
  APITypes.AppointmentFileReferencesByAppointmentIDQuery
>;
export const appointmentFileReferencesByUploadedFileID = /* GraphQL */ `query AppointmentFileReferencesByUploadedFileID(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentFileReferenceFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentFileReferencesByUploadedFileID(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentFileReferencesByUploadedFileIDQueryVariables,
  APITypes.AppointmentFileReferencesByUploadedFileIDQuery
>;
export const getUploadedFile = /* GraphQL */ `query GetUploadedFile($id: ID!) {
  getUploadedFile(id: $id) {
    id
    key
    fileName
    type
    provider
    uploadedBy
    uploadedAt
    fileSizeBytes
    fileSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    fileSetID
    sourceAppointmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUploadedFileQueryVariables,
  APITypes.GetUploadedFileQuery
>;
export const listUploadedFiles = /* GraphQL */ `query ListUploadedFiles(
  $filter: ModelUploadedFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listUploadedFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      key
      fileName
      type
      provider
      uploadedBy
      uploadedAt
      fileSizeBytes
      fileSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      fileSetID
      sourceAppointmentID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUploadedFilesQueryVariables,
  APITypes.ListUploadedFilesQuery
>;
export const uploadedFilesByFileSetID = /* GraphQL */ `query UploadedFilesByFileSetID(
  $fileSetID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUploadedFileFilterInput
  $limit: Int
  $nextToken: String
) {
  uploadedFilesByFileSetID(
    fileSetID: $fileSetID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      key
      fileName
      type
      provider
      uploadedBy
      uploadedAt
      fileSizeBytes
      fileSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      fileSetID
      sourceAppointmentID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UploadedFilesByFileSetIDQueryVariables,
  APITypes.UploadedFilesByFileSetIDQuery
>;
export const uploadedFilesBySourceAppointmentID = /* GraphQL */ `query UploadedFilesBySourceAppointmentID(
  $sourceAppointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUploadedFileFilterInput
  $limit: Int
  $nextToken: String
) {
  uploadedFilesBySourceAppointmentID(
    sourceAppointmentID: $sourceAppointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      key
      fileName
      type
      provider
      uploadedBy
      uploadedAt
      fileSizeBytes
      fileSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      fileSetID
      sourceAppointmentID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UploadedFilesBySourceAppointmentIDQueryVariables,
  APITypes.UploadedFilesBySourceAppointmentIDQuery
>;
export const getUploadedFileSet = /* GraphQL */ `query GetUploadedFileSet($id: ID!) {
  getUploadedFileSet(id: $id) {
    id
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    uploadedFiles {
      items {
        id
        key
        fileName
        type
        provider
        uploadedBy
        uploadedAt
        fileSizeBytes
        fileSet {
          id
          createdAt
          updatedAt
          __typename
        }
        fileSetID
        sourceAppointmentID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUploadedFileSetQueryVariables,
  APITypes.GetUploadedFileSetQuery
>;
export const listUploadedFileSets = /* GraphQL */ `query ListUploadedFileSets(
  $filter: ModelUploadedFileSetFilterInput
  $limit: Int
  $nextToken: String
) {
  listUploadedFileSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUploadedFileSetsQueryVariables,
  APITypes.ListUploadedFileSetsQuery
>;
export const getDocument = /* GraphQL */ `query GetDocument($id: ID!) {
  getDocument(id: $id) {
    id
    uploadedFileID
    providerTag
    pageCount
    executionArn
    recordBriefingId
    segmentSplits
    segmentIntervals {
      startPageNumber
      endPageNumber
      startLineNumber
      endLineNumber
      confidence
      confidenceReasoning
      edited
      needsReSummary
      __typename
    }
    segmentIntervalRows {
      items {
        id
        documentID
        startPageNumber
        endPageNumber
        startLineNumber
        endLineNumber
        confidence
        confidenceReasoning
        edited
        needsReSummary
        archived
        parentIntervals
        lastEditAction
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    pages {
      items {
        id
        documentID
        pageNumber
        imageS3Key
        text
        isBlank
        citations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    preview {
      bucket
      key
      __typename
    }
    hasUnresolvedSplits
    videoDurationSeconds
    ingestionSteps {
      items {
        id
        documentID
        name
        status
        startedAt
        endedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    documentMrrValidationId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentQueryVariables,
  APITypes.GetDocumentQuery
>;
export const listDocuments = /* GraphQL */ `query ListDocuments(
  $filter: ModelDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uploadedFileID
      providerTag
      pageCount
      executionArn
      recordBriefingId
      segmentSplits
      segmentIntervals {
        startPageNumber
        endPageNumber
        startLineNumber
        endLineNumber
        confidence
        confidenceReasoning
        edited
        needsReSummary
        __typename
      }
      segmentIntervalRows {
        items {
          id
          documentID
          startPageNumber
          endPageNumber
          startLineNumber
          endLineNumber
          confidence
          confidenceReasoning
          edited
          needsReSummary
          archived
          parentIntervals
          lastEditAction
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      pages {
        items {
          id
          documentID
          pageNumber
          imageS3Key
          text
          isBlank
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      preview {
        bucket
        key
        __typename
      }
      hasUnresolvedSplits
      videoDurationSeconds
      ingestionSteps {
        items {
          id
          documentID
          name
          status
          startedAt
          endedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      documentMrrValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentsQueryVariables,
  APITypes.ListDocumentsQuery
>;
export const documentsByUploadedFileID = /* GraphQL */ `query DocumentsByUploadedFileID(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  documentsByUploadedFileID(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      providerTag
      pageCount
      executionArn
      recordBriefingId
      segmentSplits
      segmentIntervals {
        startPageNumber
        endPageNumber
        startLineNumber
        endLineNumber
        confidence
        confidenceReasoning
        edited
        needsReSummary
        __typename
      }
      segmentIntervalRows {
        items {
          id
          documentID
          startPageNumber
          endPageNumber
          startLineNumber
          endLineNumber
          confidence
          confidenceReasoning
          edited
          needsReSummary
          archived
          parentIntervals
          lastEditAction
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      pages {
        items {
          id
          documentID
          pageNumber
          imageS3Key
          text
          isBlank
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      preview {
        bucket
        key
        __typename
      }
      hasUnresolvedSplits
      videoDurationSeconds
      ingestionSteps {
        items {
          id
          documentID
          name
          status
          startedAt
          endedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      documentMrrValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DocumentsByUploadedFileIDQueryVariables,
  APITypes.DocumentsByUploadedFileIDQuery
>;
export const getDocumentIngestionStep = /* GraphQL */ `query GetDocumentIngestionStep($id: ID!) {
  getDocumentIngestionStep(id: $id) {
    id
    documentID
    name
    status
    startedAt
    endedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentIngestionStepQueryVariables,
  APITypes.GetDocumentIngestionStepQuery
>;
export const listDocumentIngestionSteps = /* GraphQL */ `query ListDocumentIngestionSteps(
  $filter: ModelDocumentIngestionStepFilterInput
  $limit: Int
  $nextToken: String
) {
  listDocumentIngestionSteps(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      documentID
      name
      status
      startedAt
      endedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentIngestionStepsQueryVariables,
  APITypes.ListDocumentIngestionStepsQuery
>;
export const documentIngestionStepsByDocumentIDAndStartedAt = /* GraphQL */ `query DocumentIngestionStepsByDocumentIDAndStartedAt(
  $documentID: ID!
  $startedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentIngestionStepFilterInput
  $limit: Int
  $nextToken: String
) {
  documentIngestionStepsByDocumentIDAndStartedAt(
    documentID: $documentID
    startedAt: $startedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      documentID
      name
      status
      startedAt
      endedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DocumentIngestionStepsByDocumentIDAndStartedAtQueryVariables,
  APITypes.DocumentIngestionStepsByDocumentIDAndStartedAtQuery
>;
export const getOperationStatus = /* GraphQL */ `query GetOperationStatus($id: ID!) {
  getOperationStatus(id: $id) {
    id
    scope
    operation
    name
    status
    startedAt
    heartbeatAt
    endedAt
    attempt
    errorMessage
    correlationId
    metadata
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOperationStatusQueryVariables,
  APITypes.GetOperationStatusQuery
>;
export const listOperationStatuses = /* GraphQL */ `query ListOperationStatuses(
  $filter: ModelOperationStatusFilterInput
  $limit: Int
  $nextToken: String
) {
  listOperationStatuses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      scope
      operation
      name
      status
      startedAt
      heartbeatAt
      endedAt
      attempt
      errorMessage
      correlationId
      metadata
      expiresAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOperationStatusesQueryVariables,
  APITypes.ListOperationStatusesQuery
>;
export const operationStatusesByScopeAndStartedAt = /* GraphQL */ `query OperationStatusesByScopeAndStartedAt(
  $scope: String!
  $startedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOperationStatusFilterInput
  $limit: Int
  $nextToken: String
) {
  operationStatusesByScopeAndStartedAt(
    scope: $scope
    startedAt: $startedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scope
      operation
      name
      status
      startedAt
      heartbeatAt
      endedAt
      attempt
      errorMessage
      correlationId
      metadata
      expiresAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OperationStatusesByScopeAndStartedAtQueryVariables,
  APITypes.OperationStatusesByScopeAndStartedAtQuery
>;
export const getDocumentPage = /* GraphQL */ `query GetDocumentPage($id: ID!) {
  getDocumentPage(id: $id) {
    id
    documentID
    pageNumber
    imageS3Key
    text
    isBlank
    citations {
      items {
        id
        documentPageID
        documentID
        pageNumber
        blockIndex
        text
        bbox {
          yMin
          xMin
          yMax
          xMax
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentPageQueryVariables,
  APITypes.GetDocumentPageQuery
>;
export const listDocumentPages = /* GraphQL */ `query ListDocumentPages(
  $filter: ModelDocumentPageFilterInput
  $limit: Int
  $nextToken: String
) {
  listDocumentPages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      documentID
      pageNumber
      imageS3Key
      text
      isBlank
      citations {
        items {
          id
          documentPageID
          documentID
          pageNumber
          blockIndex
          text
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentPagesQueryVariables,
  APITypes.ListDocumentPagesQuery
>;
export const documentPagesByDocumentIDAndPageNumber = /* GraphQL */ `query DocumentPagesByDocumentIDAndPageNumber(
  $documentID: ID!
  $pageNumber: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentPageFilterInput
  $limit: Int
  $nextToken: String
) {
  documentPagesByDocumentIDAndPageNumber(
    documentID: $documentID
    pageNumber: $pageNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      documentID
      pageNumber
      imageS3Key
      text
      isBlank
      citations {
        items {
          id
          documentPageID
          documentID
          pageNumber
          blockIndex
          text
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DocumentPagesByDocumentIDAndPageNumberQueryVariables,
  APITypes.DocumentPagesByDocumentIDAndPageNumberQuery
>;
export const getCitation = /* GraphQL */ `query GetCitation($id: ID!) {
  getCitation(id: $id) {
    id
    documentPageID
    documentID
    pageNumber
    blockIndex
    text
    bbox {
      yMin
      xMin
      yMax
      xMax
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCitationQueryVariables,
  APITypes.GetCitationQuery
>;
export const listCitations = /* GraphQL */ `query ListCitations(
  $filter: ModelCitationFilterInput
  $limit: Int
  $nextToken: String
) {
  listCitations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      documentPageID
      documentID
      pageNumber
      blockIndex
      text
      bbox {
        yMin
        xMin
        yMax
        xMax
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCitationsQueryVariables,
  APITypes.ListCitationsQuery
>;
export const citationsByDocumentPageIDAndBlockIndex = /* GraphQL */ `query CitationsByDocumentPageIDAndBlockIndex(
  $documentPageID: ID!
  $blockIndex: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCitationFilterInput
  $limit: Int
  $nextToken: String
) {
  citationsByDocumentPageIDAndBlockIndex(
    documentPageID: $documentPageID
    blockIndex: $blockIndex
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      documentPageID
      documentID
      pageNumber
      blockIndex
      text
      bbox {
        yMin
        xMin
        yMax
        xMax
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CitationsByDocumentPageIDAndBlockIndexQueryVariables,
  APITypes.CitationsByDocumentPageIDAndBlockIndexQuery
>;
export const getDocumentSegmentInterval = /* GraphQL */ `query GetDocumentSegmentInterval($id: ID!) {
  getDocumentSegmentInterval(id: $id) {
    id
    documentID
    startPageNumber
    endPageNumber
    startLineNumber
    endLineNumber
    confidence
    confidenceReasoning
    edited
    needsReSummary
    archived
    parentIntervals
    lastEditAction
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentSegmentIntervalQueryVariables,
  APITypes.GetDocumentSegmentIntervalQuery
>;
export const listDocumentSegmentIntervals = /* GraphQL */ `query ListDocumentSegmentIntervals(
  $filter: ModelDocumentSegmentIntervalFilterInput
  $limit: Int
  $nextToken: String
) {
  listDocumentSegmentIntervals(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      documentID
      startPageNumber
      endPageNumber
      startLineNumber
      endLineNumber
      confidence
      confidenceReasoning
      edited
      needsReSummary
      archived
      parentIntervals
      lastEditAction
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentSegmentIntervalsQueryVariables,
  APITypes.ListDocumentSegmentIntervalsQuery
>;
export const documentSegmentIntervalsByDocumentIDAndStartPageNumber = /* GraphQL */ `query DocumentSegmentIntervalsByDocumentIDAndStartPageNumber(
  $documentID: ID!
  $startPageNumber: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentSegmentIntervalFilterInput
  $limit: Int
  $nextToken: String
) {
  documentSegmentIntervalsByDocumentIDAndStartPageNumber(
    documentID: $documentID
    startPageNumber: $startPageNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      documentID
      startPageNumber
      endPageNumber
      startLineNumber
      endLineNumber
      confidence
      confidenceReasoning
      edited
      needsReSummary
      archived
      parentIntervals
      lastEditAction
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DocumentSegmentIntervalsByDocumentIDAndStartPageNumberQueryVariables,
  APITypes.DocumentSegmentIntervalsByDocumentIDAndStartPageNumberQuery
>;
export const getAudio = /* GraphQL */ `query GetAudio($id: ID!) {
  getAudio(id: $id) {
    id
    uploadedFileID
    executionArn
    fileFormat
    durationSeconds
    transcript {
      bucket
      key
      __typename
    }
    transcriptWordCount
    transcriptGrammarCorrected {
      bucket
      key
      __typename
    }
    transcriptGrammarCorrectedWordCount
    transcriptPreview {
      bucket
      key
      __typename
    }
    detectedLanguages
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetAudioQueryVariables, APITypes.GetAudioQuery>;
export const listAudio = /* GraphQL */ `query ListAudio(
  $filter: ModelAudioFilterInput
  $limit: Int
  $nextToken: String
) {
  listAudio(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uploadedFileID
      executionArn
      fileFormat
      durationSeconds
      transcript {
        bucket
        key
        __typename
      }
      transcriptWordCount
      transcriptGrammarCorrected {
        bucket
        key
        __typename
      }
      transcriptGrammarCorrectedWordCount
      transcriptPreview {
        bucket
        key
        __typename
      }
      detectedLanguages
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListAudioQueryVariables, APITypes.ListAudioQuery>;
export const audioByUploadedFileID = /* GraphQL */ `query AudioByUploadedFileID(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAudioFilterInput
  $limit: Int
  $nextToken: String
) {
  audioByUploadedFileID(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      executionArn
      fileFormat
      durationSeconds
      transcript {
        bucket
        key
        __typename
      }
      transcriptWordCount
      transcriptGrammarCorrected {
        bucket
        key
        __typename
      }
      transcriptGrammarCorrectedWordCount
      transcriptPreview {
        bucket
        key
        __typename
      }
      detectedLanguages
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AudioByUploadedFileIDQueryVariables,
  APITypes.AudioByUploadedFileIDQuery
>;
export const getHistoryTranscript = /* GraphQL */ `query GetHistoryTranscript($id: ID!) {
  getHistoryTranscript(id: $id) {
    id
    uploadedFileID
    callId
    recordingId
    callStartTime
    callDurationSeconds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHistoryTranscriptQueryVariables,
  APITypes.GetHistoryTranscriptQuery
>;
export const listHistoryTranscripts = /* GraphQL */ `query ListHistoryTranscripts(
  $filter: ModelHistoryTranscriptFilterInput
  $limit: Int
  $nextToken: String
) {
  listHistoryTranscripts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      callId
      recordingId
      callStartTime
      callDurationSeconds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHistoryTranscriptsQueryVariables,
  APITypes.ListHistoryTranscriptsQuery
>;
export const historyTranscriptsByUploadedFileID = /* GraphQL */ `query HistoryTranscriptsByUploadedFileID(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelHistoryTranscriptFilterInput
  $limit: Int
  $nextToken: String
) {
  historyTranscriptsByUploadedFileID(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      callId
      recordingId
      callStartTime
      callDurationSeconds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HistoryTranscriptsByUploadedFileIDQueryVariables,
  APITypes.HistoryTranscriptsByUploadedFileIDQuery
>;
export const historyTranscriptsByCallId = /* GraphQL */ `query HistoryTranscriptsByCallId(
  $callId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelHistoryTranscriptFilterInput
  $limit: Int
  $nextToken: String
) {
  historyTranscriptsByCallId(
    callId: $callId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      callId
      recordingId
      callStartTime
      callDurationSeconds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HistoryTranscriptsByCallIdQueryVariables,
  APITypes.HistoryTranscriptsByCallIdQuery
>;
export const getPanelFile = /* GraphQL */ `query GetPanelFile($id: ID!) {
  getPanelFile(id: $id) {
    id
    uploadedFileID
    sourceAppointmentID
    correlationId
    panelNumber
    panelIssueDate
    numberOfRequests
    requestingParty
    claim {
      claimNumber
      dateOfInjury
      __typename
    }
    patient {
      name
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    employer {
      name
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    adjuster {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    applicantAttorney {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    defenseAttorney {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    physicians {
      name
      specialty
      address {
        street
        city
        state
        zip
        __typename
      }
      yearsInPractice
      education
      phoneNumber
      isStruck
      strikeDate
      strikeParty
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPanelFileQueryVariables,
  APITypes.GetPanelFileQuery
>;
export const listPanelFiles = /* GraphQL */ `query ListPanelFiles(
  $filter: ModelPanelFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listPanelFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uploadedFileID
      sourceAppointmentID
      correlationId
      panelNumber
      panelIssueDate
      numberOfRequests
      requestingParty
      claim {
        claimNumber
        dateOfInjury
        __typename
      }
      patient {
        name
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      employer {
        name
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      adjuster {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      applicantAttorney {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      defenseAttorney {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      physicians {
        name
        specialty
        address {
          street
          city
          state
          zip
          __typename
        }
        yearsInPractice
        education
        phoneNumber
        isStruck
        strikeDate
        strikeParty
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPanelFilesQueryVariables,
  APITypes.ListPanelFilesQuery
>;
export const panelFilesByUploadedFile = /* GraphQL */ `query PanelFilesByUploadedFile(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPanelFileFilterInput
  $limit: Int
  $nextToken: String
) {
  panelFilesByUploadedFile(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      sourceAppointmentID
      correlationId
      panelNumber
      panelIssueDate
      numberOfRequests
      requestingParty
      claim {
        claimNumber
        dateOfInjury
        __typename
      }
      patient {
        name
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      employer {
        name
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      adjuster {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      applicantAttorney {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      defenseAttorney {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      physicians {
        name
        specialty
        address {
          street
          city
          state
          zip
          __typename
        }
        yearsInPractice
        education
        phoneNumber
        isStruck
        strikeDate
        strikeParty
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PanelFilesByUploadedFileQueryVariables,
  APITypes.PanelFilesByUploadedFileQuery
>;
export const panelFilesBySourceAppointment = /* GraphQL */ `query PanelFilesBySourceAppointment(
  $sourceAppointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPanelFileFilterInput
  $limit: Int
  $nextToken: String
) {
  panelFilesBySourceAppointment(
    sourceAppointmentID: $sourceAppointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      sourceAppointmentID
      correlationId
      panelNumber
      panelIssueDate
      numberOfRequests
      requestingParty
      claim {
        claimNumber
        dateOfInjury
        __typename
      }
      patient {
        name
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      employer {
        name
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      adjuster {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      applicantAttorney {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      defenseAttorney {
        name
        company
        address {
          street
          city
          state
          zip
          __typename
        }
        __typename
      }
      physicians {
        name
        specialty
        address {
          street
          city
          state
          zip
          __typename
        }
        yearsInPractice
        education
        phoneNumber
        isStruck
        strikeDate
        strikeParty
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PanelFilesBySourceAppointmentQueryVariables,
  APITypes.PanelFilesBySourceAppointmentQuery
>;
export const getNotes = /* GraphQL */ `query GetNotes($id: ID!) {
  getNotes(id: $id) {
    id
    content
    author {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    type
    timeStamp
    appointmentrecordID
    createdAt
    updatedAt
    notesAuthorId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetNotesQueryVariables, APITypes.GetNotesQuery>;
export const listNotes = /* GraphQL */ `query ListNotes(
  $filter: ModelNotesFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListNotesQueryVariables, APITypes.ListNotesQuery>;
export const notesByAppointmentrecordID = /* GraphQL */ `query NotesByAppointmentrecordID(
  $appointmentrecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelNotesFilterInput
  $limit: Int
  $nextToken: String
) {
  notesByAppointmentrecordID(
    appointmentrecordID: $appointmentrecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotesByAppointmentrecordIDQueryVariables,
  APITypes.NotesByAppointmentrecordIDQuery
>;
export const getHuddleNote = /* GraphQL */ `query GetHuddleNote($id: ID!) {
  getHuddleNote(id: $id) {
    id
    appointmentRecordID
    contentMarkdown
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHuddleNoteQueryVariables,
  APITypes.GetHuddleNoteQuery
>;
export const listHuddleNotes = /* GraphQL */ `query ListHuddleNotes(
  $filter: ModelHuddleNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listHuddleNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      appointmentRecordID
      contentMarkdown
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHuddleNotesQueryVariables,
  APITypes.ListHuddleNotesQuery
>;
export const huddleNotesByAppointmentRecord = /* GraphQL */ `query HuddleNotesByAppointmentRecord(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelHuddleNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  huddleNotesByAppointmentRecord(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      contentMarkdown
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HuddleNotesByAppointmentRecordQueryVariables,
  APITypes.HuddleNotesByAppointmentRecordQuery
>;
export const getMedicalAssistant = /* GraphQL */ `query GetMedicalAssistant($id: ID!) {
  getMedicalAssistant(id: $id) {
    id
    name
    email
    preVisitCallScheduleLink
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    enableCalendarNotify
    inactive
    languages
    assignmentCriteria {
      languageWeights {
        language
        weight
        doctorSpecialty
        __typename
      }
      __typename
    }
    isDemo
    dismissedProTips
    phoneNumber
    joinedDate
    level
    capacityPercent
    supportedDoctors {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    supportedSpecialtyCategories {
      items {
        id
        medicalAssistantId
        specialtyCategoryId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        specialtyCategory {
          id
          name
          specialties
          createdAt
          updatedAt
          specialtyCategoryFallbackMAId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    availabilityExceptions {
      type
      during {
        start
        end
        __typename
      }
      startTime
      endTime
      allDay
      __typename
    }
    roles
    createdAt
    updatedAt
    medicalAssistantUserId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMedicalAssistantQueryVariables,
  APITypes.GetMedicalAssistantQuery
>;
export const listMedicalAssistants = /* GraphQL */ `query ListMedicalAssistants(
  $filter: ModelMedicalAssistantFilterInput
  $limit: Int
  $nextToken: String
) {
  listMedicalAssistants(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMedicalAssistantsQueryVariables,
  APITypes.ListMedicalAssistantsQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    cognitoUserId
    avatarUrl
    firstName
    lastName
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    assistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentFilterPreset {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    onboardingDismissals {
      itemId
      dismissedAt
      __typename
    }
    settings {
      opsChecklistDefaultExpanded
      __typename
    }
    createdAt
    updatedAt
    userDoctorId
    userAssistantId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const usersByCognitoUserId = /* GraphQL */ `query UsersByCognitoUserId(
  $cognitoUserId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByCognitoUserId(
    cognitoUserId: $cognitoUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByCognitoUserIdQueryVariables,
  APITypes.UsersByCognitoUserIdQuery
>;
export const getStoredAddress = /* GraphQL */ `query GetStoredAddress($id: ID!) {
  getStoredAddress(id: $id) {
    id
    street
    city
    state
    zip
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStoredAddressQueryVariables,
  APITypes.GetStoredAddressQuery
>;
export const listStoredAddresses = /* GraphQL */ `query ListStoredAddresses(
  $filter: ModelStoredAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  listStoredAddresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStoredAddressesQueryVariables,
  APITypes.ListStoredAddressesQuery
>;
export const storedAddressesByInsuranceCarrierID = /* GraphQL */ `query StoredAddressesByInsuranceCarrierID(
  $insuranceCarrierID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStoredAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  storedAddressesByInsuranceCarrierID(
    insuranceCarrierID: $insuranceCarrierID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoredAddressesByInsuranceCarrierIDQueryVariables,
  APITypes.StoredAddressesByInsuranceCarrierIDQuery
>;
export const storedAddressesByLawFirmID = /* GraphQL */ `query StoredAddressesByLawFirmID(
  $lawFirmID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStoredAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  storedAddressesByLawFirmID(
    lawFirmID: $lawFirmID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoredAddressesByLawFirmIDQueryVariables,
  APITypes.StoredAddressesByLawFirmIDQuery
>;
export const getStoredFaxNumber = /* GraphQL */ `query GetStoredFaxNumber($id: ID!) {
  getStoredFaxNumber(id: $id) {
    id
    faxNumber
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStoredFaxNumberQueryVariables,
  APITypes.GetStoredFaxNumberQuery
>;
export const listStoredFaxNumbers = /* GraphQL */ `query ListStoredFaxNumbers(
  $filter: ModelStoredFaxNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  listStoredFaxNumbers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStoredFaxNumbersQueryVariables,
  APITypes.ListStoredFaxNumbersQuery
>;
export const storedFaxNumbersByInsuranceCarrierID = /* GraphQL */ `query StoredFaxNumbersByInsuranceCarrierID(
  $insuranceCarrierID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStoredFaxNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  storedFaxNumbersByInsuranceCarrierID(
    insuranceCarrierID: $insuranceCarrierID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoredFaxNumbersByInsuranceCarrierIDQueryVariables,
  APITypes.StoredFaxNumbersByInsuranceCarrierIDQuery
>;
export const storedFaxNumbersByLawFirmID = /* GraphQL */ `query StoredFaxNumbersByLawFirmID(
  $lawFirmID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStoredFaxNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  storedFaxNumbersByLawFirmID(
    lawFirmID: $lawFirmID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoredFaxNumbersByLawFirmIDQueryVariables,
  APITypes.StoredFaxNumbersByLawFirmIDQuery
>;
export const getStoredPhoneNumber = /* GraphQL */ `query GetStoredPhoneNumber($id: ID!) {
  getStoredPhoneNumber(id: $id) {
    id
    phoneNumber
    extension
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStoredPhoneNumberQueryVariables,
  APITypes.GetStoredPhoneNumberQuery
>;
export const listStoredPhoneNumbers = /* GraphQL */ `query ListStoredPhoneNumbers(
  $filter: ModelStoredPhoneNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  listStoredPhoneNumbers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStoredPhoneNumbersQueryVariables,
  APITypes.ListStoredPhoneNumbersQuery
>;
export const storedPhoneNumbersByInsuranceCarrierID = /* GraphQL */ `query StoredPhoneNumbersByInsuranceCarrierID(
  $insuranceCarrierID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStoredPhoneNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  storedPhoneNumbersByInsuranceCarrierID(
    insuranceCarrierID: $insuranceCarrierID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoredPhoneNumbersByInsuranceCarrierIDQueryVariables,
  APITypes.StoredPhoneNumbersByInsuranceCarrierIDQuery
>;
export const storedPhoneNumbersByLawFirmID = /* GraphQL */ `query StoredPhoneNumbersByLawFirmID(
  $lawFirmID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStoredPhoneNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  storedPhoneNumbersByLawFirmID(
    lawFirmID: $lawFirmID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoredPhoneNumbersByLawFirmIDQueryVariables,
  APITypes.StoredPhoneNumbersByLawFirmIDQuery
>;
export const getFaxJob = /* GraphQL */ `query GetFaxJob($id: ID!) {
  getFaxJob(id: $id) {
    id
    appointmentID
    uploadedFileID
    recipientParty
    recipientEntityID
    faxNumber
    iFaxJobId
    status
    failureCode
    failureMessage
    submittedAt
    completedAt
    submittedByUserID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetFaxJobQueryVariables, APITypes.GetFaxJobQuery>;
export const listFaxJobs = /* GraphQL */ `query ListFaxJobs(
  $filter: ModelFaxJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listFaxJobs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      appointmentID
      uploadedFileID
      recipientParty
      recipientEntityID
      faxNumber
      iFaxJobId
      status
      failureCode
      failureMessage
      submittedAt
      completedAt
      submittedByUserID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFaxJobsQueryVariables,
  APITypes.ListFaxJobsQuery
>;
export const faxJobsByAppointment = /* GraphQL */ `query FaxJobsByAppointment(
  $appointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFaxJobFilterInput
  $limit: Int
  $nextToken: String
) {
  faxJobsByAppointment(
    appointmentID: $appointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      recipientParty
      recipientEntityID
      faxNumber
      iFaxJobId
      status
      failureCode
      failureMessage
      submittedAt
      completedAt
      submittedByUserID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FaxJobsByAppointmentQueryVariables,
  APITypes.FaxJobsByAppointmentQuery
>;
export const faxJobsByUploadedFile = /* GraphQL */ `query FaxJobsByUploadedFile(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFaxJobFilterInput
  $limit: Int
  $nextToken: String
) {
  faxJobsByUploadedFile(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      recipientParty
      recipientEntityID
      faxNumber
      iFaxJobId
      status
      failureCode
      failureMessage
      submittedAt
      completedAt
      submittedByUserID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FaxJobsByUploadedFileQueryVariables,
  APITypes.FaxJobsByUploadedFileQuery
>;
export const faxJobsByIFaxJobId = /* GraphQL */ `query FaxJobsByIFaxJobId(
  $iFaxJobId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelFaxJobFilterInput
  $limit: Int
  $nextToken: String
) {
  faxJobsByIFaxJobId(
    iFaxJobId: $iFaxJobId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      recipientParty
      recipientEntityID
      faxNumber
      iFaxJobId
      status
      failureCode
      failureMessage
      submittedAt
      completedAt
      submittedByUserID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FaxJobsByIFaxJobIdQueryVariables,
  APITypes.FaxJobsByIFaxJobIdQuery
>;
export const faxJobsBySubmitter = /* GraphQL */ `query FaxJobsBySubmitter(
  $submittedByUserID: ID!
  $submittedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFaxJobFilterInput
  $limit: Int
  $nextToken: String
) {
  faxJobsBySubmitter(
    submittedByUserID: $submittedByUserID
    submittedAt: $submittedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      recipientParty
      recipientEntityID
      faxNumber
      iFaxJobId
      status
      failureCode
      failureMessage
      submittedAt
      completedAt
      submittedByUserID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FaxJobsBySubmitterQueryVariables,
  APITypes.FaxJobsBySubmitterQuery
>;
export const getN110PartyDelivery = /* GraphQL */ `query GetN110PartyDelivery($id: ID!) {
  getN110PartyDelivery(id: $id) {
    id
    appointmentID
    uploadedFileID
    party
    status
    reason
    driveFileID
    uploadedAt
    submittedByUserID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetN110PartyDeliveryQueryVariables,
  APITypes.GetN110PartyDeliveryQuery
>;
export const listN110PartyDeliveries = /* GraphQL */ `query ListN110PartyDeliveries(
  $filter: ModelN110PartyDeliveryFilterInput
  $limit: Int
  $nextToken: String
) {
  listN110PartyDeliveries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      party
      status
      reason
      driveFileID
      uploadedAt
      submittedByUserID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListN110PartyDeliveriesQueryVariables,
  APITypes.ListN110PartyDeliveriesQuery
>;
export const n110PartyDeliveriesByAppointment = /* GraphQL */ `query N110PartyDeliveriesByAppointment(
  $appointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelN110PartyDeliveryFilterInput
  $limit: Int
  $nextToken: String
) {
  n110PartyDeliveriesByAppointment(
    appointmentID: $appointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      party
      status
      reason
      driveFileID
      uploadedAt
      submittedByUserID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.N110PartyDeliveriesByAppointmentQueryVariables,
  APITypes.N110PartyDeliveriesByAppointmentQuery
>;
export const n110PartyDeliveriesBySubmitter = /* GraphQL */ `query N110PartyDeliveriesBySubmitter(
  $submittedByUserID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelN110PartyDeliveryFilterInput
  $limit: Int
  $nextToken: String
) {
  n110PartyDeliveriesBySubmitter(
    submittedByUserID: $submittedByUserID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      uploadedFileID
      party
      status
      reason
      driveFileID
      uploadedAt
      submittedByUserID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.N110PartyDeliveriesBySubmitterQueryVariables,
  APITypes.N110PartyDeliveriesBySubmitterQuery
>;
export const getInsuranceCarrier = /* GraphQL */ `query GetInsuranceCarrier($id: ID!) {
  getInsuranceCarrier(id: $id) {
    id
    name
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultEmail
    supportedDomains
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInsuranceCarrierQueryVariables,
  APITypes.GetInsuranceCarrierQuery
>;
export const listInsuranceCarriers = /* GraphQL */ `query ListInsuranceCarriers(
  $filter: ModelInsuranceCarrierFilterInput
  $limit: Int
  $nextToken: String
) {
  listInsuranceCarriers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInsuranceCarriersQueryVariables,
  APITypes.ListInsuranceCarriersQuery
>;
export const getLawFirm = /* GraphQL */ `query GetLawFirm($id: ID!) {
  getLawFirm(id: $id) {
    id
    name
    type
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultEmail
    supportedDomains
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLawFirmQueryVariables,
  APITypes.GetLawFirmQuery
>;
export const listLawFirms = /* GraphQL */ `query ListLawFirms(
  $filter: ModelLawFirmFilterInput
  $limit: Int
  $nextToken: String
) {
  listLawFirms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLawFirmsQueryVariables,
  APITypes.ListLawFirmsQuery
>;
export const lawFirmsByType = /* GraphQL */ `query LawFirmsByType(
  $type: LawFirmType!
  $sortDirection: ModelSortDirection
  $filter: ModelLawFirmFilterInput
  $limit: Int
  $nextToken: String
) {
  lawFirmsByType(
    type: $type
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LawFirmsByTypeQueryVariables,
  APITypes.LawFirmsByTypeQuery
>;
export const getGlobalBillingCounter = /* GraphQL */ `query GetGlobalBillingCounter($id: ID!) {
  getGlobalBillingCounter(id: $id) {
    id
    count
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGlobalBillingCounterQueryVariables,
  APITypes.GetGlobalBillingCounterQuery
>;
export const listGlobalBillingCounters = /* GraphQL */ `query ListGlobalBillingCounters(
  $filter: ModelGlobalBillingCounterFilterInput
  $limit: Int
  $nextToken: String
) {
  listGlobalBillingCounters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      count
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGlobalBillingCountersQueryVariables,
  APITypes.ListGlobalBillingCountersQuery
>;
export const getCaseRecord = /* GraphQL */ `query GetCaseRecord($id: ID!) {
  getCaseRecord(id: $id) {
    id
    state
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCaseRecordQueryVariables,
  APITypes.GetCaseRecordQuery
>;
export const listCaseRecords = /* GraphQL */ `query ListCaseRecords(
  $filter: ModelCaseRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  listCaseRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      state
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCaseRecordsQueryVariables,
  APITypes.ListCaseRecordsQuery
>;
export const getAppointmentRecord = /* GraphQL */ `query GetAppointmentRecord($id: ID!) {
  getAppointmentRecord(id: $id) {
    id
    doctorOwnerCognitoId
    assistantCognitoIds
    globalPartitionKey
    originalAppointmentID
    supplementalAppointmentIDs
    supplementalSourceAppointmentIDs
    depositionAppointmentIDs
    depositionSourceAppointmentIDs
    rescheduledFromAppointmentID
    rescheduledToAppointmentID
    date
    yearMonth
    doctorYearMonth
    time
    bookedInFlexibleTime
    inquiryDate
    inquiryYearMonth
    type
    doctorID
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    locationID
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    visitForm
    jotformSubmissions {
      id
      receivedAt
      populatedAt
      __typename
    }
    historyTranscriptPopulations {
      uploadedFileID
      populatedAt
      __typename
    }
    active
    durationMinutes
    reportDue
    reportSubmitted
    status
    reportStatus
    paymentStatus
    billingStatus
    difficultyLevel
    scheduler {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    schedulingAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    onSiteOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    reportOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    billingOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    preVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    inquirerInfo {
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      inquiringParty
      name
      inquiryDate
      notification_110_required
      __typename
    }
    notes {
      items {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      nextToken
      __typename
    }
    huddleNote {
      id
      appointmentRecordID
      contentMarkdown
      createdAt
      updatedAt
      __typename
    }
    patientCases {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    employments {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    employmentGaps {
      type
      startDate {
        value
        precision
        __typename
      }
      endDate {
        value
        precision
        __typename
      }
      notes
      __typename
    }
    patientDescribedInjuries
    uploadedFilesSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    uploadedFilesSetID
    referredBy
    s3FileKey
    medicalRecordsReceived
    medicalRecordsBriefingFileID
    medicalRecordsBriefingExecutionArn
    medicalRecordsTotalPagesProcessed
    reportGenerationFileID
    reportGenerationExecutionArn
    reportGenerationGeneratedAt
    historyOfInjuryFileID
    historyOfInjuryGeneratedAt
    evaluationFileID
    assessmentFileID
    depositionPreparationFileID
    documentStatus {
      evaluationPublished
      assessmentPublished
      historyInProgress
      historyPublished
      historyCleaned
      reportPublished
      briefingInProgress
      briefingPublished
      briefingCleaned
      __typename
    }
    cancellationReason
    cancellationRequestedBy
    cancellationRequestedInternally
    cancellationNote
    cancellationDate
    inquiryClosingReason
    inquiryClosingNote
    inquiryClosingDate
    noShowReason
    noShowNote
    reschedulingReason
    reschedulingOthersReason
    reschedulingRequestedBy
    reschedulingRequestedInternally
    reschedulingNote
    reschedulingDate
    interpreter {
      certificateId
      name
      companyName
      phoneNumber
      phoneExtension
      note
      confirmed
      __typename
    }
    historyOfInjuryNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    currentComplaintNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    historyCallDate
    historyCallTime
    historyCallAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    historyCallCompleted
    historyCallCompletedWithoutRecords
    historyCallCompletedOnSite
    historyCallNoShow
    historyCallCalendarEventID
    historyCallCalendarLink
    billingInfo {
      diagnosisMappings {
        code
        pointer
        description
        __typename
      }
      serviceDetails {
        dateOfStart
        dateOfEnd
        place
        emergencyIndicator
        serviceType
        modifiers
        diagnosisPointers
        chargedAmount
        quantity
        amountPaid
        renderingProviderId
        __typename
      }
      totalCharge
      amountPaid
      billingCounter
      billedDate
      paidDate
      correctionDate
      __typename
    }
    caseInfo {
      confirmationEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      recordsFollowupEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      attendanceEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      __typename
    }
    isProd
    isDemo
    primaryPatientCaseID
    calendarEventID
    reportConfiguration {
      history
      physicalExamination
      assessment
      __typename
    }
    workflowExecutions {
      items {
        executionArn
        appointmentRecordID
        type
        status
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    historyOfInjuryInsights {
      id
      appointmentRecordID
      mechanismOfInjury
      employerJobDescription
      injuryCausations {
        injuryType
        dateOfInjury
        dateOfInjuryEnd
        bodyParts
        mechanismOfInjury
        employerJobDescription
        __typename
      }
      currentSymptoms {
        bodyParts
        description
        __typename
      }
      priorSymptomsBeforeCurrentInjury {
        bodyParts
        description
        __typename
      }
      previousSurgeries {
        date
        bodyParts
        type
        __typename
      }
      previousWorkInjuries {
        date
        bodyParts
        description
        __typename
      }
      previousInjuries {
        date
        bodyParts
        description
        __typename
      }
      injuryEmploymentStatus
      currentWorkRestrictionsFromPatient
      activitiesOfDailyLiving
      createdAt
      updatedAt
      __typename
    }
    reviewOfMedicalRecordsInsights {
      id
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      derivedFromDocumentInsightIDs
      derivedAt
      createdAt
      updatedAt
      __typename
    }
    physicalExamInsights {
      id
      appointmentRecordID
      physicalExaminationInfo
      createdAt
      updatedAt
      __typename
    }
    pastInjuryMatrix {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    briefing {
      id
      logicalBriefingID
      segmentMappings {
        items {
          id
          briefingID
          logicalSegmentID
          publishedSegmentID
          draftSegmentID
          markedForDeletion
          markedForCreation
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      generatedAt
      lastEditedAt
      lastEditedBy
      googleDocExportLink
      googleDocExportedAt
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
        __typename
      }
      editingPresence
      createdAt
      updatedAt
      __typename
    }
    introParagraph {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
        __typename
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    impairmentRatingResults {
      ts
      bodyParts
      enabledStrictRating
      enabledPainRating
      enabledAG
      enabledStrengthRating
      enabledDBE
      autoMode
      result
      resultFeedback {
        exists
        isGood
        notes
        __typename
      }
      __typename
    }
    defenseAttorneyPagesDeclaration
    applicantAttorneyPagesDeclaration
    fieldTemplateRef {
      id
      version
      __typename
    }
    dataFieldValuesMappings {
      dataFieldID
      value
      __typename
    }
    physicalEvalTemplateRef {
      id
      version
      __typename
    }
    physicalExamValues {
      sectionID
      questionID
      side
      value
      note
      excluded
      __typename
    }
    physicalExamOtherFindings {
      sectionID
      text
      __typename
    }
    assessment {
      id
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussedBodyParts
      bodyPartsNotDiscussedReason
      discussions
      diagnoses {
        diagnosis
        icdCode
        evidenceSources
        evidence
        __typename
      }
      bodyPartMMIStatus {
        discussByBodyPart
        allBodyPartsMMI {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        bodyPartMMIStatuses {
          bodyPart
          __typename
        }
        __typename
      }
      workStatus
      markedAsDone
      discussDiagnosesFreeForm
      diagnosesFreeform
      discussCausationFreeForm
      causationFreeForm
      discussMMIImpairmentRatingApportionmentFreeForm
      hasPatientReachedMMIFreeForm
      discussMMIByBodyPartFreeForm
      impairmentRatingByBodyPartFreeForm
      apportionmentByBodyPartFreeForm
      impairmentRatingOtherComments
      apportionmentOtherComments
      assessmentMode
      assessmentFreeForm {
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussions
        diagnosesAndEvidence
        causation
        hasPatientReachedMMI
        discussMMIByBodyPart
        impairmentRatingByBodyPart
        apportionmentByBodyPart
        workStatus
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    assessmentValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    opinionRecap {
      id
      appointmentRecordID
      causation
      diagnosis
      mmiFutureMedicalTreatment
      impairmentRating
      apportionment
      workStatus
      sourceReportFileID
      createdAt
      updatedAt
      __typename
    }
    tempUploadedIntakeFormS3Keys
    featureFlags {
      featureFlagKey
      enabled
      __typename
    }
    opsChecklist {
      panel
      contact_info
      all_parties
      notice_110
      cover_letter
      record_review
      history_call
      history_of_injury
      interpreter_info
      jotform
      deu_100
      final_report
      __typename
    }
    panelUnavailable
    panelSpecialty
    defenseAttorneyNotPresent
    applicantAttorneyNotPresent
    contactUnavailability {
      patient {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      adjuster {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      applicantAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      defenseAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      __typename
    }
    historyValidation {
      id
      appointmentRecordID
      status
      groups {
        id
        title
        status
        issues {
          id
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      validatedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    patientHistoryValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    videoCallLink
    additionalTimeslots {
      date
      time
      locationID
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    historyMrrCrossValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    caseID
    briefingModelVersion
    briefingGdocExportLink
    briefingGdocExportedAt
    createdAt
    updatedAt
    appointmentRecordMedicalAssistantId
    appointmentRecordSchedulingAssistantId
    appointmentRecordOnSiteOpId
    appointmentRecordReportOpId
    appointmentRecordBillingOpId
    appointmentRecordPreVisitReviewerId
    appointmentRecordHuddleNoteId
    appointmentRecordHistoryOfInjuryNotesId
    appointmentRecordCurrentComplaintNotesId
    appointmentRecordHistoryCallAssistantId
    appointmentRecordHistoryOfInjuryInsightsId
    appointmentRecordReviewOfMedicalRecordsInsightsId
    appointmentRecordPhysicalExamInsightsId
    appointmentRecordPastInjuryMatrixId
    appointmentRecordBriefingId
    appointmentRecordIntroParagraphId
    appointmentRecordAssessmentId
    appointmentRecordAssessmentValidationId
    appointmentRecordOpinionRecapId
    appointmentRecordHistoryValidationId
    appointmentRecordPatientHistoryValidationId
    appointmentRecordMrrValidationId
    appointmentRecordHistoryMrrCrossValidationId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAppointmentRecordQueryVariables,
  APITypes.GetAppointmentRecordQuery
>;
export const listAppointmentRecords = /* GraphQL */ `query ListAppointmentRecords(
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  listAppointmentRecords(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAppointmentRecordsQueryVariables,
  APITypes.ListAppointmentRecordsQuery
>;
export const appointmentsByGlobalDateTime = /* GraphQL */ `query AppointmentsByGlobalDateTime(
  $globalPartitionKey: String!
  $dateTime: ModelAppointmentRecordByGlobalDateTimeCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByGlobalDateTime(
    globalPartitionKey: $globalPartitionKey
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentsByGlobalDateTimeQueryVariables,
  APITypes.AppointmentsByGlobalDateTimeQuery
>;
export const appointmentsByGlobalInquiryDate = /* GraphQL */ `query AppointmentsByGlobalInquiryDate(
  $globalPartitionKey: String!
  $inquiryDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByGlobalInquiryDate(
    globalPartitionKey: $globalPartitionKey
    inquiryDate: $inquiryDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentsByGlobalInquiryDateQueryVariables,
  APITypes.AppointmentsByGlobalInquiryDateQuery
>;
export const appointmentsByGlobalReportDue = /* GraphQL */ `query AppointmentsByGlobalReportDue(
  $globalPartitionKey: String!
  $reportDue: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByGlobalReportDue(
    globalPartitionKey: $globalPartitionKey
    reportDue: $reportDue
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentsByGlobalReportDueQueryVariables,
  APITypes.AppointmentsByGlobalReportDueQuery
>;
export const appointmentRecordsByOriginalAppointmentID = /* GraphQL */ `query AppointmentRecordsByOriginalAppointmentID(
  $originalAppointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordsByOriginalAppointmentID(
    originalAppointmentID: $originalAppointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentRecordsByOriginalAppointmentIDQueryVariables,
  APITypes.AppointmentRecordsByOriginalAppointmentIDQuery
>;
export const appointmentsByInquiryYearMonth = /* GraphQL */ `query AppointmentsByInquiryYearMonth(
  $inquiryYearMonth: String!
  $inquiryDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByInquiryYearMonth(
    inquiryYearMonth: $inquiryYearMonth
    inquiryDate: $inquiryDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentsByInquiryYearMonthQueryVariables,
  APITypes.AppointmentsByInquiryYearMonthQuery
>;
export const appointmentRecordsByDoctorIDAndDateAndTime = /* GraphQL */ `query AppointmentRecordsByDoctorIDAndDateAndTime(
  $doctorID: ID!
  $dateTime: ModelAppointmentRecordByDoctorCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordsByDoctorIDAndDateAndTime(
    doctorID: $doctorID
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentRecordsByDoctorIDAndDateAndTimeQueryVariables,
  APITypes.AppointmentRecordsByDoctorIDAndDateAndTimeQuery
>;
export const appointmentRecordsByLocationIDAndDateAndTime = /* GraphQL */ `query AppointmentRecordsByLocationIDAndDateAndTime(
  $locationID: ID!
  $dateTime: ModelAppointmentRecordByLocationCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordsByLocationIDAndDateAndTime(
    locationID: $locationID
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentRecordsByLocationIDAndDateAndTimeQueryVariables,
  APITypes.AppointmentRecordsByLocationIDAndDateAndTimeQuery
>;
export const appointmentRecordsByUploadedFilesSetID = /* GraphQL */ `query AppointmentRecordsByUploadedFilesSetID(
  $uploadedFilesSetID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordsByUploadedFilesSetID(
    uploadedFilesSetID: $uploadedFilesSetID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentRecordsByUploadedFilesSetIDQueryVariables,
  APITypes.AppointmentRecordsByUploadedFilesSetIDQuery
>;
export const appointmentsByCase = /* GraphQL */ `query AppointmentsByCase(
  $caseID: ID!
  $dateTime: ModelAppointmentRecordByCaseCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByCase(
    caseID: $caseID
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentsByCaseQueryVariables,
  APITypes.AppointmentsByCaseQuery
>;
export const getPatient = /* GraphQL */ `query GetPatient($id: ID!) {
  getPatient(id: $id) {
    id
    name
    dateOfBirth
    SSN
    language
    dominantHand
    cases {
      items {
        id
        patientID
        patient {
          id
          name
          dateOfBirth
          SSN
          language
          dominantHand
          occupation
          sex
          weightLb
          createdAt
          updatedAt
          __typename
        }
        claimNumber
        qmePanelNumber
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        injuryInfo {
          injuryType
          injuredBodyParts
          claimedBodyParts
          description
          dateOfInjury
          startDateOfInjury
          __typename
        }
        workersCompInsurance {
          insuranceCarrier
          adjuster
          __typename
        }
        insuranceCarrierID
        insuranceCarrier {
          id
          name
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierAddressID
        insuranceCarrierAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierFaxNumberID
        insuranceCarrierFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierPhoneNumberID
        insuranceCarrierPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        applicantAttorney {
          name
          lawFirmName
          __typename
        }
        applicantAttorneyLawFirmID
        applicantAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyAddressID
        applicantAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyFaxNumberID
        applicantAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyPhoneNumberID
        applicantAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorney {
          name
          lawFirmName
          __typename
        }
        defenseAttorneyLawFirmID
        defenseAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyAddressID
        defenseAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyFaxNumberID
        defenseAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyPhoneNumberID
        defenseAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nurseCaseManager {
          name
          organizationName
          __typename
        }
        ccPerson {
          name
          organizationName
          __typename
        }
        applicantAttorneyCcEmails
        defenseAttorneyCcEmails
        adjusterCcEmails
        scheduledCommsSuppressedParties
        employmentAtInjury {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        WCAB
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    occupation
    sex
    weightLb
    height {
      feet
      inches
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPatientQueryVariables,
  APITypes.GetPatientQuery
>;
export const listPatients = /* GraphQL */ `query ListPatients(
  $filter: ModelPatientFilterInput
  $limit: Int
  $nextToken: String
) {
  listPatients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      dateOfBirth
      SSN
      language
      dominantHand
      cases {
        items {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      occupation
      sex
      weightLb
      height {
        feet
        inches
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPatientsQueryVariables,
  APITypes.ListPatientsQuery
>;
export const getPatientCase = /* GraphQL */ `query GetPatientCase($id: ID!) {
  getPatientCase(id: $id) {
    id
    patientID
    patient {
      id
      name
      dateOfBirth
      SSN
      language
      dominantHand
      cases {
        items {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      occupation
      sex
      weightLb
      height {
        feet
        inches
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    claimNumber
    qmePanelNumber
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    injuryInfo {
      injuryType
      injuredBodyParts
      claimedBodyParts
      description
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      startDateOfInjury
      startDateOfInjuryFlexible {
        value
        precision
        __typename
      }
      __typename
    }
    workersCompInsurance {
      insuranceCarrier
      adjuster
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    insuranceCarrierID
    insuranceCarrier {
      id
      name
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierAddressID
    insuranceCarrierAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierFaxNumberID
    insuranceCarrierFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierPhoneNumberID
    insuranceCarrierPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    appointments {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    applicantAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyLawFirmID
    applicantAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyAddressID
    applicantAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyFaxNumberID
    applicantAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyPhoneNumberID
    applicantAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    defenseAttorneyLawFirmID
    defenseAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyAddressID
    defenseAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyFaxNumberID
    defenseAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyPhoneNumberID
    defenseAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nurseCaseManager {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    ccPerson {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyCcEmails
    defenseAttorneyCcEmails
    adjusterCcEmails
    scheduledCommsSuppressedParties
    employmentAtInjury {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    WCAB
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPatientCaseQueryVariables,
  APITypes.GetPatientCaseQuery
>;
export const listPatientCases = /* GraphQL */ `query ListPatientCases(
  $filter: ModelPatientCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listPatientCases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPatientCasesQueryVariables,
  APITypes.ListPatientCasesQuery
>;
export const patientCasesByPatientID = /* GraphQL */ `query PatientCasesByPatientID(
  $patientID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPatientCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  patientCasesByPatientID(
    patientID: $patientID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PatientCasesByPatientIDQueryVariables,
  APITypes.PatientCasesByPatientIDQuery
>;
export const getDoctor = /* GraphQL */ `query GetDoctor($id: ID!) {
  getDoctor(id: $id) {
    id
    ownerCognitoId
    firstName
    middleName
    lastName
    name
    signatureName
    status
    ramped
    title
    titleExtension
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    officePhone
    cellPhone
    clinicPhone
    workCity
    workState
    collectionRate
    licenseNumber
    licenseRenewalDate
    qmeLicense {
      licenseNumber
      approvalDate
      renewalDate
      __typename
    }
    locations {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    specialties
    npi
    bankingInfo {
      bankEntityName
      accountNumber
      routingNumber
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    availabilities {
      generalAvailabilities {
        during {
          start
          end
          __typename
        }
        recurrence
        dayOfWeek
        dayOfMonth
        weekOfMonth
        monthInterval
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      additionalAvailabilities {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      blackoutDates {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      __typename
    }
    availabilitiesNote
    emails
    profileImages {
      type
      name
      order
      s3Prefix
      widthInInches
      heightInInches
      __typename
    }
    qmeReportConfigs {
      hasIntroTitle
      introTemplate
      __typename
    }
    physicalEvalConfigs {
      templates
      __typename
    }
    signatureDepartment
    profileAssetS3Prefix
    calendarPreference {
      mailingList
      showPatientFullName
      showPatientAddress
      showPatientDOB
      showPortalLink
      __typename
    }
    homeOffice {
      county
      state
      __typename
    }
    reportFormatPreferences {
      evaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      reEvaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      supplementalReport {
        sections
        assessmentSubSections
        __typename
      }
      __typename
    }
    evaluationInputPreferences {
      evaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      reEvaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      supplementalReport {
        assessment
        __typename
      }
      __typename
    }
    preferredAssessmentMode
    caseSummaryFields {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingFields {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    isDemo
    fieldTemplateId
    templateFolderLink
    physicianPartner {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPrimaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSecondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSupplementalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    supplementalReportOpsAssignments {
      medicalAssistantID
      weightPercentage
      __typename
    }
    supportingMAs {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    defaultAppointmentDurationMinutes {
      qme
      qmeReevaluation
      ime
      deposition
      __typename
    }
    defaultEarlyArrivalTimeMinutes {
      workersComp
      ime
      deposition
      __typename
    }
    assessmentTreatmentOptions
    dismissedProTips
    createdAt
    updatedAt
    doctorPhysicianPartnerId
    doctorDefaultPrimaryOnsiteOpsId
    doctorDefaultSecondaryOnsiteOpsId
    doctorDefaultSchedulerId
    doctorDefaultReportOpsId
    doctorDefaultPreVisitReviewerId
    doctorDefaultBillingOpsId
    doctorDefaultSupplementalReportOpsId
    doctorUserId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetDoctorQueryVariables, APITypes.GetDoctorQuery>;
export const listDoctors = /* GraphQL */ `query ListDoctors(
  $filter: ModelDoctorFilterInput
  $limit: Int
  $nextToken: String
) {
  listDoctors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDoctorsQueryVariables,
  APITypes.ListDoctorsQuery
>;
export const getLocation = /* GraphQL */ `query GetLocation($id: ID!) {
  getLocation(id: $id) {
    id
    name
    abbreviation
    status
    region
    address {
      street
      city
      state
      zip
      county
      __typename
    }
    indigoOfficePhoneNumber
    isWaitingArea
    additionalRoomsNumber
    landlordContactInfo {
      name
      phone
      email
      __typename
    }
    calendarCcEmails
    isParkingFree
    parkingRate
    isFrontDoorLocked
    frontDoorCode
    backDoor
    backDoorCode
    securityUnlockingProcess
    securityLockingProcess
    maleBathroomCode
    femaleBathroomCode
    wifiName
    wifiPassword
    defaultOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    locationInstructionsForVisitor
    additionalNote
    doctors {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    locationDefaultOnsiteOpsId
    locationSecondaryOnsiteOpsId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLocationQueryVariables,
  APITypes.GetLocationQuery
>;
export const listLocations = /* GraphQL */ `query ListLocations(
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLocationsQueryVariables,
  APITypes.ListLocationsQuery
>;
export const getWorkflowExecution = /* GraphQL */ `query GetWorkflowExecution($executionArn: ID!) {
  getWorkflowExecution(executionArn: $executionArn) {
    executionArn
    appointmentRecordID
    type
    status
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkflowExecutionQueryVariables,
  APITypes.GetWorkflowExecutionQuery
>;
export const listWorkflowExecutions = /* GraphQL */ `query ListWorkflowExecutions(
  $executionArn: ID
  $filter: ModelWorkflowExecutionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkflowExecutions(
    executionArn: $executionArn
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      executionArn
      appointmentRecordID
      type
      status
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkflowExecutionsQueryVariables,
  APITypes.ListWorkflowExecutionsQuery
>;
export const workflowExecutionsByAppointmentRecordID = /* GraphQL */ `query WorkflowExecutionsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWorkflowExecutionFilterInput
  $limit: Int
  $nextToken: String
) {
  workflowExecutionsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      executionArn
      appointmentRecordID
      type
      status
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WorkflowExecutionsByAppointmentRecordIDQueryVariables,
  APITypes.WorkflowExecutionsByAppointmentRecordIDQuery
>;
export const getHistoryOfInjuryInsights = /* GraphQL */ `query GetHistoryOfInjuryInsights($id: ID!) {
  getHistoryOfInjuryInsights(id: $id) {
    id
    appointmentRecordID
    mechanismOfInjury
    employerJobDescription
    injuryCausations {
      injuryType
      dateOfInjury
      dateOfInjuryEnd
      bodyParts
      mechanismOfInjury
      employerJobDescription
      __typename
    }
    currentSymptoms {
      bodyParts
      description
      __typename
    }
    priorSymptomsBeforeCurrentInjury {
      bodyParts
      description
      __typename
    }
    previousSurgeries {
      date
      bodyParts
      type
      __typename
    }
    previousWorkInjuries {
      date
      bodyParts
      description
      __typename
    }
    previousInjuries {
      date
      bodyParts
      description
      __typename
    }
    injuryEmploymentStatus
    currentWorkRestrictionsFromPatient
    activitiesOfDailyLiving
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHistoryOfInjuryInsightsQueryVariables,
  APITypes.GetHistoryOfInjuryInsightsQuery
>;
export const listHistoryOfInjuryInsights = /* GraphQL */ `query ListHistoryOfInjuryInsights(
  $id: ID
  $filter: ModelHistoryOfInjuryInsightsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listHistoryOfInjuryInsights(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      mechanismOfInjury
      employerJobDescription
      injuryCausations {
        injuryType
        dateOfInjury
        dateOfInjuryEnd
        bodyParts
        mechanismOfInjury
        employerJobDescription
        __typename
      }
      currentSymptoms {
        bodyParts
        description
        __typename
      }
      priorSymptomsBeforeCurrentInjury {
        bodyParts
        description
        __typename
      }
      previousSurgeries {
        date
        bodyParts
        type
        __typename
      }
      previousWorkInjuries {
        date
        bodyParts
        description
        __typename
      }
      previousInjuries {
        date
        bodyParts
        description
        __typename
      }
      injuryEmploymentStatus
      currentWorkRestrictionsFromPatient
      activitiesOfDailyLiving
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHistoryOfInjuryInsightsQueryVariables,
  APITypes.ListHistoryOfInjuryInsightsQuery
>;
export const getOpinionRecap = /* GraphQL */ `query GetOpinionRecap($id: ID!) {
  getOpinionRecap(id: $id) {
    id
    appointmentRecordID
    causation
    diagnosis
    mmiFutureMedicalTreatment
    impairmentRating
    apportionment
    workStatus
    sourceReportFileID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOpinionRecapQueryVariables,
  APITypes.GetOpinionRecapQuery
>;
export const listOpinionRecaps = /* GraphQL */ `query ListOpinionRecaps(
  $id: ID
  $filter: ModelOpinionRecapFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listOpinionRecaps(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      causation
      diagnosis
      mmiFutureMedicalTreatment
      impairmentRating
      apportionment
      workStatus
      sourceReportFileID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOpinionRecapsQueryVariables,
  APITypes.ListOpinionRecapsQuery
>;
export const getReviewOfMedicalRecordsInsights = /* GraphQL */ `query GetReviewOfMedicalRecordsInsights($id: ID!) {
  getReviewOfMedicalRecordsInsights(id: $id) {
    id
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    derivedFromDocumentInsightIDs
    derivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReviewOfMedicalRecordsInsightsQueryVariables,
  APITypes.GetReviewOfMedicalRecordsInsightsQuery
>;
export const listReviewOfMedicalRecordsInsights = /* GraphQL */ `query ListReviewOfMedicalRecordsInsights(
  $id: ID
  $filter: ModelReviewOfMedicalRecordsInsightsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReviewOfMedicalRecordsInsights(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      derivedFromDocumentInsightIDs
      derivedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReviewOfMedicalRecordsInsightsQueryVariables,
  APITypes.ListReviewOfMedicalRecordsInsightsQuery
>;
export const getDocumentBriefingInsights = /* GraphQL */ `query GetDocumentBriefingInsights($id: ID!) {
  getDocumentBriefingInsights(id: $id) {
    id
    documentID
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    sourceRecordBriefingID
    generatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentBriefingInsightsQueryVariables,
  APITypes.GetDocumentBriefingInsightsQuery
>;
export const listDocumentBriefingInsights = /* GraphQL */ `query ListDocumentBriefingInsights(
  $id: ID
  $filter: ModelDocumentBriefingInsightsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDocumentBriefingInsights(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      documentID
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      sourceRecordBriefingID
      generatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentBriefingInsightsQueryVariables,
  APITypes.ListDocumentBriefingInsightsQuery
>;
export const documentBriefingInsightsByDocument = /* GraphQL */ `query DocumentBriefingInsightsByDocument(
  $documentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentBriefingInsightsFilterInput
  $limit: Int
  $nextToken: String
) {
  documentBriefingInsightsByDocument(
    documentID: $documentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      documentID
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      sourceRecordBriefingID
      generatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DocumentBriefingInsightsByDocumentQueryVariables,
  APITypes.DocumentBriefingInsightsByDocumentQuery
>;
export const documentBriefingInsightsByAppointmentRecordID = /* GraphQL */ `query DocumentBriefingInsightsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentBriefingInsightsFilterInput
  $limit: Int
  $nextToken: String
) {
  documentBriefingInsightsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      documentID
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      sourceRecordBriefingID
      generatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DocumentBriefingInsightsByAppointmentRecordIDQueryVariables,
  APITypes.DocumentBriefingInsightsByAppointmentRecordIDQuery
>;
export const getPhysicalExamInsights = /* GraphQL */ `query GetPhysicalExamInsights($id: ID!) {
  getPhysicalExamInsights(id: $id) {
    id
    appointmentRecordID
    physicalExaminationInfo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPhysicalExamInsightsQueryVariables,
  APITypes.GetPhysicalExamInsightsQuery
>;
export const listPhysicalExamInsights = /* GraphQL */ `query ListPhysicalExamInsights(
  $id: ID
  $filter: ModelPhysicalExamInsightsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPhysicalExamInsights(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      physicalExaminationInfo
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPhysicalExamInsightsQueryVariables,
  APITypes.ListPhysicalExamInsightsQuery
>;
export const getDataField = /* GraphQL */ `query GetDataField($id: ID!) {
  getDataField(id: $id) {
    id
    name
    category
    dataType
    default
    description
    sectionID
    section {
      id
      name
      default
      fields {
        items {
          id
          name
          category
          dataType
          default
          description
          sectionID
          migrationKey
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    migrationKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDataFieldQueryVariables,
  APITypes.GetDataFieldQuery
>;
export const listDataFields = /* GraphQL */ `query ListDataFields(
  $id: ID
  $filter: ModelDataFieldFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDataFields(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      category
      dataType
      default
      description
      sectionID
      section {
        id
        name
        default
        fields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      migrationKey
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDataFieldsQueryVariables,
  APITypes.ListDataFieldsQuery
>;
export const dataFieldsByCategory = /* GraphQL */ `query DataFieldsByCategory(
  $category: DataFieldCategory!
  $sortDirection: ModelSortDirection
  $filter: ModelDataFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  dataFieldsByCategory(
    category: $category
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      category
      dataType
      default
      description
      sectionID
      section {
        id
        name
        default
        fields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      migrationKey
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DataFieldsByCategoryQueryVariables,
  APITypes.DataFieldsByCategoryQuery
>;
export const dataFieldsBySectionID = /* GraphQL */ `query DataFieldsBySectionID(
  $sectionID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDataFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  dataFieldsBySectionID(
    sectionID: $sectionID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      category
      dataType
      default
      description
      sectionID
      section {
        id
        name
        default
        fields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      migrationKey
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DataFieldsBySectionIDQueryVariables,
  APITypes.DataFieldsBySectionIDQuery
>;
export const getDataFieldSection = /* GraphQL */ `query GetDataFieldSection($id: ID!) {
  getDataFieldSection(id: $id) {
    id
    name
    default
    fields {
      items {
        id
        name
        category
        dataType
        default
        description
        sectionID
        section {
          id
          name
          default
          createdAt
          updatedAt
          __typename
        }
        migrationKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDataFieldSectionQueryVariables,
  APITypes.GetDataFieldSectionQuery
>;
export const listDataFieldSections = /* GraphQL */ `query ListDataFieldSections(
  $id: ID
  $filter: ModelDataFieldSectionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDataFieldSections(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      default
      fields {
        items {
          id
          name
          category
          dataType
          default
          description
          sectionID
          migrationKey
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDataFieldSectionsQueryVariables,
  APITypes.ListDataFieldSectionsQuery
>;
export const getBriefingField = /* GraphQL */ `query GetBriefingField($id: ID!) {
  getBriefingField(id: $id) {
    id
    name
    default
    description
    briefingPrompt
    doctors {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingRecordTypeID
    recordType {
      id
      name
      recordType
      description
      default
      classificationPrompt
      recordBasePrompt
      briefingFields {
        items {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBriefingFieldQueryVariables,
  APITypes.GetBriefingFieldQuery
>;
export const listBriefingFields = /* GraphQL */ `query ListBriefingFields(
  $id: ID
  $filter: ModelBriefingFieldFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBriefingFields(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBriefingFieldsQueryVariables,
  APITypes.ListBriefingFieldsQuery
>;
export const briefingFieldsByBriefingRecordTypeID = /* GraphQL */ `query BriefingFieldsByBriefingRecordTypeID(
  $briefingRecordTypeID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelBriefingFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  briefingFieldsByBriefingRecordTypeID(
    briefingRecordTypeID: $briefingRecordTypeID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BriefingFieldsByBriefingRecordTypeIDQueryVariables,
  APITypes.BriefingFieldsByBriefingRecordTypeIDQuery
>;
export const getBriefingRecordType = /* GraphQL */ `query GetBriefingRecordType($id: ID!) {
  getBriefingRecordType(id: $id) {
    id
    name
    recordType
    description
    default
    classificationPrompt
    recordBasePrompt
    briefingFields {
      items {
        id
        name
        default
        description
        briefingPrompt
        doctors {
          nextToken
          __typename
        }
        briefingRecordTypeID
        recordType {
          id
          name
          recordType
          description
          default
          classificationPrompt
          recordBasePrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBriefingRecordTypeQueryVariables,
  APITypes.GetBriefingRecordTypeQuery
>;
export const listBriefingRecordTypes = /* GraphQL */ `query ListBriefingRecordTypes(
  $id: ID
  $filter: ModelBriefingRecordTypeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBriefingRecordTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      recordType
      description
      default
      classificationPrompt
      recordBasePrompt
      briefingFields {
        items {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBriefingRecordTypesQueryVariables,
  APITypes.ListBriefingRecordTypesQuery
>;
export const getCaseSummaryField = /* GraphQL */ `query GetCaseSummaryField($id: ID!) {
  getCaseSummaryField(id: $id) {
    id
    name
    default
    description
    summaryPrompt
    doctors {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCaseSummaryFieldQueryVariables,
  APITypes.GetCaseSummaryFieldQuery
>;
export const listCaseSummaryFields = /* GraphQL */ `query ListCaseSummaryFields(
  $id: ID
  $filter: ModelCaseSummaryFieldFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCaseSummaryFields(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      default
      description
      summaryPrompt
      doctors {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCaseSummaryFieldsQueryVariables,
  APITypes.ListCaseSummaryFieldsQuery
>;
export const getPastInjuryMatrix = /* GraphQL */ `query GetPastInjuryMatrix($id: ID!) {
  getPastInjuryMatrix(id: $id) {
    id
    appointmentRecordID
    preExistingConditions
    familyHistory
    injuryMatrix {
      date
      bodyPart
      status
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPastInjuryMatrixQueryVariables,
  APITypes.GetPastInjuryMatrixQuery
>;
export const listPastInjuryMatrices = /* GraphQL */ `query ListPastInjuryMatrices(
  $id: ID
  $filter: ModelPastInjuryMatrixFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPastInjuryMatrices(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPastInjuryMatricesQueryVariables,
  APITypes.ListPastInjuryMatricesQuery
>;
export const pastInjuryMatricesByAppointmentRecordID = /* GraphQL */ `query PastInjuryMatricesByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPastInjuryMatrixFilterInput
  $limit: Int
  $nextToken: String
) {
  pastInjuryMatricesByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PastInjuryMatricesByAppointmentRecordIDQueryVariables,
  APITypes.PastInjuryMatricesByAppointmentRecordIDQuery
>;
export const getAppointmentFilterPreset = /* GraphQL */ `query GetAppointmentFilterPreset($id: ID!) {
  getAppointmentFilterPreset(id: $id) {
    id
    name
    filters {
      type
      values
      __typename
    }
    appliesTo
    view
    users {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAppointmentFilterPresetQueryVariables,
  APITypes.GetAppointmentFilterPresetQuery
>;
export const listAppointmentFilterPresets = /* GraphQL */ `query ListAppointmentFilterPresets(
  $filter: ModelAppointmentFilterPresetFilterInput
  $limit: Int
  $nextToken: String
) {
  listAppointmentFilterPresets(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      filters {
        type
        values
        __typename
      }
      appliesTo
      view
      users {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAppointmentFilterPresetsQueryVariables,
  APITypes.ListAppointmentFilterPresetsQuery
>;
export const getFeatureFlag = /* GraphQL */ `query GetFeatureFlag($key: ID!) {
  getFeatureFlag(key: $key) {
    key
    enabled
    enabledForUserIds
    enabledForRoles
    enabledForDoctorIds
    description
    variants {
      variant
      percentage
      __typename
    }
    seed
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFeatureFlagQueryVariables,
  APITypes.GetFeatureFlagQuery
>;
export const listFeatureFlags = /* GraphQL */ `query ListFeatureFlags(
  $key: ID
  $filter: ModelFeatureFlagFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFeatureFlags(
    key: $key
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      key
      enabled
      enabledForUserIds
      enabledForRoles
      enabledForDoctorIds
      description
      variants {
        variant
        percentage
        __typename
      }
      seed
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFeatureFlagsQueryVariables,
  APITypes.ListFeatureFlagsQuery
>;
export const getFeatureFlagVariantAssignment = /* GraphQL */ `query GetFeatureFlagVariantAssignment($assignmentId: ID!) {
  getFeatureFlagVariantAssignment(assignmentId: $assignmentId) {
    assignmentId
    flagKey
    subjectId
    variant
    assignedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFeatureFlagVariantAssignmentQueryVariables,
  APITypes.GetFeatureFlagVariantAssignmentQuery
>;
export const listFeatureFlagVariantAssignments = /* GraphQL */ `query ListFeatureFlagVariantAssignments(
  $assignmentId: ID
  $filter: ModelFeatureFlagVariantAssignmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFeatureFlagVariantAssignments(
    assignmentId: $assignmentId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      assignmentId
      flagKey
      subjectId
      variant
      assignedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFeatureFlagVariantAssignmentsQueryVariables,
  APITypes.ListFeatureFlagVariantAssignmentsQuery
>;
export const featureFlagVariantAssignmentsByFlagKeyAndAssignedAt = /* GraphQL */ `query FeatureFlagVariantAssignmentsByFlagKeyAndAssignedAt(
  $flagKey: ID!
  $assignedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFeatureFlagVariantAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  featureFlagVariantAssignmentsByFlagKeyAndAssignedAt(
    flagKey: $flagKey
    assignedAt: $assignedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      assignmentId
      flagKey
      subjectId
      variant
      assignedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FeatureFlagVariantAssignmentsByFlagKeyAndAssignedAtQueryVariables,
  APITypes.FeatureFlagVariantAssignmentsByFlagKeyAndAssignedAtQuery
>;
export const featureFlagVariantAssignmentsBySubjectIdAndAssignedAt = /* GraphQL */ `query FeatureFlagVariantAssignmentsBySubjectIdAndAssignedAt(
  $subjectId: ID!
  $assignedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFeatureFlagVariantAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  featureFlagVariantAssignmentsBySubjectIdAndAssignedAt(
    subjectId: $subjectId
    assignedAt: $assignedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      assignmentId
      flagKey
      subjectId
      variant
      assignedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FeatureFlagVariantAssignmentsBySubjectIdAndAssignedAtQueryVariables,
  APITypes.FeatureFlagVariantAssignmentsBySubjectIdAndAssignedAtQuery
>;
export const getRecordBriefingSegment = /* GraphQL */ `query GetRecordBriefingSegment($id: ID!) {
  getRecordBriefingSegment(id: $id) {
    id
    logicalSegmentID
    title
    text
    bodyParts
    injuredBodyParts
    editedBy
    pdfFileName
    sourceTag
    segmentNumber
    sourcePdfS3Key
    startPageNumber
    endPageNumber
    recordType
    extractedDate
    doctorName
    processingModel
    classificationConfidence
    hasDate
    potentialDuplicateID
    needsReview
    status
    documentID
    videoStartTime
    videoEndTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecordBriefingSegmentQueryVariables,
  APITypes.GetRecordBriefingSegmentQuery
>;
export const listRecordBriefingSegments = /* GraphQL */ `query ListRecordBriefingSegments(
  $id: ID
  $filter: ModelRecordBriefingSegmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRecordBriefingSegments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecordBriefingSegmentsQueryVariables,
  APITypes.ListRecordBriefingSegmentsQuery
>;
export const recordBriefingSegmentsByLogicalId = /* GraphQL */ `query RecordBriefingSegmentsByLogicalId(
  $logicalSegmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecordBriefingSegmentFilterInput
  $limit: Int
  $nextToken: String
) {
  recordBriefingSegmentsByLogicalId(
    logicalSegmentID: $logicalSegmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RecordBriefingSegmentsByLogicalIdQueryVariables,
  APITypes.RecordBriefingSegmentsByLogicalIdQuery
>;
export const getRecordBriefingSegmentMapping = /* GraphQL */ `query GetRecordBriefingSegmentMapping($id: ID!) {
  getRecordBriefingSegmentMapping(id: $id) {
    id
    briefingID
    logicalSegmentID
    publishedSegmentID
    draftSegmentID
    markedForDeletion
    markedForCreation
    publishedSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    draftSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecordBriefingSegmentMappingQueryVariables,
  APITypes.GetRecordBriefingSegmentMappingQuery
>;
export const listRecordBriefingSegmentMappings = /* GraphQL */ `query ListRecordBriefingSegmentMappings(
  $id: ID
  $filter: ModelRecordBriefingSegmentMappingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRecordBriefingSegmentMappings(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      briefingID
      logicalSegmentID
      publishedSegmentID
      draftSegmentID
      markedForDeletion
      markedForCreation
      publishedSegment {
        id
        logicalSegmentID
        title
        text
        bodyParts
        injuredBodyParts
        editedBy
        pdfFileName
        sourceTag
        segmentNumber
        sourcePdfS3Key
        startPageNumber
        endPageNumber
        recordType
        extractedDate
        doctorName
        processingModel
        classificationConfidence
        hasDate
        potentialDuplicateID
        needsReview
        status
        documentID
        videoStartTime
        videoEndTime
        createdAt
        updatedAt
        __typename
      }
      draftSegment {
        id
        logicalSegmentID
        title
        text
        bodyParts
        injuredBodyParts
        editedBy
        pdfFileName
        sourceTag
        segmentNumber
        sourcePdfS3Key
        startPageNumber
        endPageNumber
        recordType
        extractedDate
        doctorName
        processingModel
        classificationConfidence
        hasDate
        potentialDuplicateID
        needsReview
        status
        documentID
        videoStartTime
        videoEndTime
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecordBriefingSegmentMappingsQueryVariables,
  APITypes.ListRecordBriefingSegmentMappingsQuery
>;
export const segmentMappingsByBriefingId = /* GraphQL */ `query SegmentMappingsByBriefingId(
  $briefingID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecordBriefingSegmentMappingFilterInput
  $limit: Int
  $nextToken: String
) {
  segmentMappingsByBriefingId(
    briefingID: $briefingID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      briefingID
      logicalSegmentID
      publishedSegmentID
      draftSegmentID
      markedForDeletion
      markedForCreation
      publishedSegment {
        id
        logicalSegmentID
        title
        text
        bodyParts
        injuredBodyParts
        editedBy
        pdfFileName
        sourceTag
        segmentNumber
        sourcePdfS3Key
        startPageNumber
        endPageNumber
        recordType
        extractedDate
        doctorName
        processingModel
        classificationConfidence
        hasDate
        potentialDuplicateID
        needsReview
        status
        documentID
        videoStartTime
        videoEndTime
        createdAt
        updatedAt
        __typename
      }
      draftSegment {
        id
        logicalSegmentID
        title
        text
        bodyParts
        injuredBodyParts
        editedBy
        pdfFileName
        sourceTag
        segmentNumber
        sourcePdfS3Key
        startPageNumber
        endPageNumber
        recordType
        extractedDate
        doctorName
        processingModel
        classificationConfidence
        hasDate
        potentialDuplicateID
        needsReview
        status
        documentID
        videoStartTime
        videoEndTime
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SegmentMappingsByBriefingIdQueryVariables,
  APITypes.SegmentMappingsByBriefingIdQuery
>;
export const getRecordBriefing = /* GraphQL */ `query GetRecordBriefing($id: ID!) {
  getRecordBriefing(id: $id) {
    id
    logicalBriefingID
    segmentMappings {
      items {
        id
        briefingID
        logicalSegmentID
        publishedSegmentID
        draftSegmentID
        markedForDeletion
        markedForCreation
        publishedSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        draftSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    generatedAt
    lastEditedAt
    lastEditedBy
    googleDocExportLink
    googleDocExportedAt
    suggestionGeneration {
      status
      jobId
      startedAt
      completedAt
      error
      __typename
    }
    editingPresence
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecordBriefingQueryVariables,
  APITypes.GetRecordBriefingQuery
>;
export const listRecordBriefings = /* GraphQL */ `query ListRecordBriefings(
  $id: ID
  $filter: ModelRecordBriefingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRecordBriefings(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      logicalBriefingID
      segmentMappings {
        items {
          id
          briefingID
          logicalSegmentID
          publishedSegmentID
          draftSegmentID
          markedForDeletion
          markedForCreation
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      generatedAt
      lastEditedAt
      lastEditedBy
      googleDocExportLink
      googleDocExportedAt
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
        __typename
      }
      editingPresence
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecordBriefingsQueryVariables,
  APITypes.ListRecordBriefingsQuery
>;
export const recordBriefingsByLogicalId = /* GraphQL */ `query RecordBriefingsByLogicalId(
  $logicalBriefingID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecordBriefingFilterInput
  $limit: Int
  $nextToken: String
) {
  recordBriefingsByLogicalId(
    logicalBriefingID: $logicalBriefingID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      logicalBriefingID
      segmentMappings {
        items {
          id
          briefingID
          logicalSegmentID
          publishedSegmentID
          draftSegmentID
          markedForDeletion
          markedForCreation
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      generatedAt
      lastEditedAt
      lastEditedBy
      googleDocExportLink
      googleDocExportedAt
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
        __typename
      }
      editingPresence
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RecordBriefingsByLogicalIdQueryVariables,
  APITypes.RecordBriefingsByLogicalIdQuery
>;
export const getRecordBriefingSegmentAnnotation = /* GraphQL */ `query GetRecordBriefingSegmentAnnotation($id: ID!, $logicalSegmentID: String!) {
  getRecordBriefingSegmentAnnotation(
    id: $id
    logicalSegmentID: $logicalSegmentID
  ) {
    id
    logicalSegmentID
    isStarred
    isImportant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecordBriefingSegmentAnnotationQueryVariables,
  APITypes.GetRecordBriefingSegmentAnnotationQuery
>;
export const listRecordBriefingSegmentAnnotations = /* GraphQL */ `query ListRecordBriefingSegmentAnnotations(
  $id: ID
  $logicalSegmentID: ModelStringKeyConditionInput
  $filter: ModelRecordBriefingSegmentAnnotationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRecordBriefingSegmentAnnotations(
    id: $id
    logicalSegmentID: $logicalSegmentID
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      logicalSegmentID
      isStarred
      isImportant
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecordBriefingSegmentAnnotationsQueryVariables,
  APITypes.ListRecordBriefingSegmentAnnotationsQuery
>;
export const getRecordBriefingSegmentSuggestion = /* GraphQL */ `query GetRecordBriefingSegmentSuggestion($id: ID!) {
  getRecordBriefingSegmentSuggestion(id: $id) {
    id
    briefingID
    logicalSegmentID
    suggestionType
    reason
    reasonDetails
    textRange {
      textToDelete
      occurrenceIndex
      prefixContext
      suffixContext
      __typename
    }
    status
    resolvedBy
    resolvedAt
    seen
    confidence
    relatedSegmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecordBriefingSegmentSuggestionQueryVariables,
  APITypes.GetRecordBriefingSegmentSuggestionQuery
>;
export const listRecordBriefingSegmentSuggestions = /* GraphQL */ `query ListRecordBriefingSegmentSuggestions(
  $id: ID
  $filter: ModelRecordBriefingSegmentSuggestionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRecordBriefingSegmentSuggestions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      briefingID
      logicalSegmentID
      suggestionType
      reason
      reasonDetails
      textRange {
        textToDelete
        occurrenceIndex
        prefixContext
        suffixContext
        __typename
      }
      status
      resolvedBy
      resolvedAt
      seen
      confidence
      relatedSegmentID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecordBriefingSegmentSuggestionsQueryVariables,
  APITypes.ListRecordBriefingSegmentSuggestionsQuery
>;
export const suggestionsByBriefingId = /* GraphQL */ `query SuggestionsByBriefingId(
  $briefingID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecordBriefingSegmentSuggestionFilterInput
  $limit: Int
  $nextToken: String
) {
  suggestionsByBriefingId(
    briefingID: $briefingID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      briefingID
      logicalSegmentID
      suggestionType
      reason
      reasonDetails
      textRange {
        textToDelete
        occurrenceIndex
        prefixContext
        suffixContext
        __typename
      }
      status
      resolvedBy
      resolvedAt
      seen
      confidence
      relatedSegmentID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SuggestionsByBriefingIdQueryVariables,
  APITypes.SuggestionsByBriefingIdQuery
>;
export const getSummaryCitation = /* GraphQL */ `query GetSummaryCitation($id: ID!) {
  getSummaryCitation(id: $id) {
    id
    briefingID
    logicalSegmentID
    summaryText
    citationID
    status
    removedBy
    removedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSummaryCitationQueryVariables,
  APITypes.GetSummaryCitationQuery
>;
export const listSummaryCitations = /* GraphQL */ `query ListSummaryCitations(
  $id: ID
  $filter: ModelSummaryCitationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSummaryCitations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      briefingID
      logicalSegmentID
      summaryText
      citationID
      status
      removedBy
      removedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSummaryCitationsQueryVariables,
  APITypes.ListSummaryCitationsQuery
>;
export const summaryCitationsByBriefingId = /* GraphQL */ `query SummaryCitationsByBriefingId(
  $briefingID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSummaryCitationFilterInput
  $limit: Int
  $nextToken: String
) {
  summaryCitationsByBriefingId(
    briefingID: $briefingID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      briefingID
      logicalSegmentID
      summaryText
      citationID
      status
      removedBy
      removedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SummaryCitationsByBriefingIdQueryVariables,
  APITypes.SummaryCitationsByBriefingIdQuery
>;
export const summaryCitationsByLogicalSegmentId = /* GraphQL */ `query SummaryCitationsByLogicalSegmentId(
  $logicalSegmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSummaryCitationFilterInput
  $limit: Int
  $nextToken: String
) {
  summaryCitationsByLogicalSegmentId(
    logicalSegmentID: $logicalSegmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      briefingID
      logicalSegmentID
      summaryText
      citationID
      status
      removedBy
      removedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SummaryCitationsByLogicalSegmentIdQueryVariables,
  APITypes.SummaryCitationsByLogicalSegmentIdQuery
>;
export const getSuggestion = /* GraphQL */ `query GetSuggestion($id: ID!) {
  getSuggestion(id: $id) {
    id
    appointmentID
    source
    changeType
    resourceURI
    suggestedValue
    existingValue
    rationale
    status
    resolvedByUserID
    resolvedAt
    versionID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSuggestionQueryVariables,
  APITypes.GetSuggestionQuery
>;
export const listSuggestions = /* GraphQL */ `query ListSuggestions(
  $id: ID
  $filter: ModelSuggestionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSuggestions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentID
      source
      changeType
      resourceURI
      suggestedValue
      existingValue
      rationale
      status
      resolvedByUserID
      resolvedAt
      versionID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSuggestionsQueryVariables,
  APITypes.ListSuggestionsQuery
>;
export const suggestionsByAppointment = /* GraphQL */ `query SuggestionsByAppointment(
  $appointmentID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSuggestionFilterInput
  $limit: Int
  $nextToken: String
) {
  suggestionsByAppointment(
    appointmentID: $appointmentID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      source
      changeType
      resourceURI
      suggestedValue
      existingValue
      rationale
      status
      resolvedByUserID
      resolvedAt
      versionID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SuggestionsByAppointmentQueryVariables,
  APITypes.SuggestionsByAppointmentQuery
>;
export const suggestionsByVersion = /* GraphQL */ `query SuggestionsByVersion(
  $versionID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSuggestionFilterInput
  $limit: Int
  $nextToken: String
) {
  suggestionsByVersion(
    versionID: $versionID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      source
      changeType
      resourceURI
      suggestedValue
      existingValue
      rationale
      status
      resolvedByUserID
      resolvedAt
      versionID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SuggestionsByVersionQueryVariables,
  APITypes.SuggestionsByVersionQuery
>;
export const getOnsiteOpsConfig = /* GraphQL */ `query GetOnsiteOpsConfig($doctorLocationKey: ID!) {
  getOnsiteOpsConfig(doctorLocationKey: $doctorLocationKey) {
    doctorLocationKey
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryMedicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    assignmentEffectiveDate
    createdAt
    updatedAt
    onsiteOpsConfigDoctorId
    onsiteOpsConfigLocationId
    onsiteOpsConfigMedicalAssistantId
    onsiteOpsConfigSecondaryMedicalAssistantId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOnsiteOpsConfigQueryVariables,
  APITypes.GetOnsiteOpsConfigQuery
>;
export const listOnsiteOpsConfigs = /* GraphQL */ `query ListOnsiteOpsConfigs(
  $doctorLocationKey: ID
  $filter: ModelOnsiteOpsConfigFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listOnsiteOpsConfigs(
    doctorLocationKey: $doctorLocationKey
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      doctorLocationKey
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryMedicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      assignmentEffectiveDate
      createdAt
      updatedAt
      onsiteOpsConfigDoctorId
      onsiteOpsConfigLocationId
      onsiteOpsConfigMedicalAssistantId
      onsiteOpsConfigSecondaryMedicalAssistantId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOnsiteOpsConfigsQueryVariables,
  APITypes.ListOnsiteOpsConfigsQuery
>;
export const getOpsGlobalSettings = /* GraphQL */ `query GetOpsGlobalSettings($key: ID!) {
  getOpsGlobalSettings(key: $key) {
    key
    inPersonEvaluationPreVisitDurationDays
    supplementalPreVisitDurationDays
    depositionPreVisitDurationDays
    defaultGlobalOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalMA {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentTypeMAAssignments {
      appointmentType
      maWeights {
        medicalAssistantID
        weightPercentage
        __typename
      }
      __typename
    }
    maAssignmentCapacitySettings {
      level1WeeklyPointBudget
      level2WeeklyPointBudget
      level3WeeklyPointBudget
      level4WeeklyPointBudget
      maxAppointmentsPerMAWeek
      maxAppointmentsPerMADay
      __typename
    }
    bodyPartSpecialtiesMappings {
      bodyPart
      specialties
      __typename
    }
    createdAt
    updatedAt
    opsGlobalSettingsDefaultGlobalOnsiteOpsId
    opsGlobalSettingsDefaultGlobalMAId
    opsGlobalSettingsDefaultGlobalSchedulerId
    opsGlobalSettingsDefaultGlobalReportOpsId
    opsGlobalSettingsDefaultGlobalPreVisitReviewerId
    opsGlobalSettingsDefaultGlobalBillingOpsId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOpsGlobalSettingsQueryVariables,
  APITypes.GetOpsGlobalSettingsQuery
>;
export const listOpsGlobalSettings = /* GraphQL */ `query ListOpsGlobalSettings(
  $key: ID
  $filter: ModelOpsGlobalSettingsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listOpsGlobalSettings(
    key: $key
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      key
      inPersonEvaluationPreVisitDurationDays
      supplementalPreVisitDurationDays
      depositionPreVisitDurationDays
      defaultGlobalOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultGlobalMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultGlobalScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultGlobalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultGlobalPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultGlobalBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentTypeMAAssignments {
        appointmentType
        maWeights {
          medicalAssistantID
          weightPercentage
          __typename
        }
        __typename
      }
      maAssignmentCapacitySettings {
        level1WeeklyPointBudget
        level2WeeklyPointBudget
        level3WeeklyPointBudget
        level4WeeklyPointBudget
        maxAppointmentsPerMAWeek
        maxAppointmentsPerMADay
        __typename
      }
      bodyPartSpecialtiesMappings {
        bodyPart
        specialties
        __typename
      }
      createdAt
      updatedAt
      opsGlobalSettingsDefaultGlobalOnsiteOpsId
      opsGlobalSettingsDefaultGlobalMAId
      opsGlobalSettingsDefaultGlobalSchedulerId
      opsGlobalSettingsDefaultGlobalReportOpsId
      opsGlobalSettingsDefaultGlobalPreVisitReviewerId
      opsGlobalSettingsDefaultGlobalBillingOpsId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOpsGlobalSettingsQueryVariables,
  APITypes.ListOpsGlobalSettingsQuery
>;
export const getSpecialtyCategory = /* GraphQL */ `query GetSpecialtyCategory($id: ID!) {
  getSpecialtyCategory(id: $id) {
    id
    name
    specialties
    fallbackMA {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    medicalAssistants {
      items {
        id
        medicalAssistantId
        specialtyCategoryId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        specialtyCategory {
          id
          name
          specialties
          createdAt
          updatedAt
          specialtyCategoryFallbackMAId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    specialtyCategoryFallbackMAId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSpecialtyCategoryQueryVariables,
  APITypes.GetSpecialtyCategoryQuery
>;
export const listSpecialtyCategories = /* GraphQL */ `query ListSpecialtyCategories(
  $filter: ModelSpecialtyCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listSpecialtyCategories(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      specialties
      fallbackMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      medicalAssistants {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      specialtyCategoryFallbackMAId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSpecialtyCategoriesQueryVariables,
  APITypes.ListSpecialtyCategoriesQuery
>;
export const getCoverLetterRecap = /* GraphQL */ `query GetCoverLetterRecap($id: ID!) {
  getCoverLetterRecap(id: $id) {
    id
    uploadedFileID
    recapText
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCoverLetterRecapQueryVariables,
  APITypes.GetCoverLetterRecapQuery
>;
export const listCoverLetterRecaps = /* GraphQL */ `query ListCoverLetterRecaps(
  $filter: ModelCoverLetterRecapFilterInput
  $limit: Int
  $nextToken: String
) {
  listCoverLetterRecaps(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uploadedFileID
      recapText
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCoverLetterRecapsQueryVariables,
  APITypes.ListCoverLetterRecapsQuery
>;
export const coverLetterRecapsByUploadedFileID = /* GraphQL */ `query CoverLetterRecapsByUploadedFileID(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCoverLetterRecapFilterInput
  $limit: Int
  $nextToken: String
) {
  coverLetterRecapsByUploadedFileID(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      recapText
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CoverLetterRecapsByUploadedFileIDQueryVariables,
  APITypes.CoverLetterRecapsByUploadedFileIDQuery
>;
export const getIntroParagraph = /* GraphQL */ `query GetIntroParagraph($id: ID!) {
  getIntroParagraph(id: $id) {
    id
    appointmentRecordID
    introParagraphText
    sourceRecaps {
      coverLetterRecapID
      uploadedFileID
      recapText
      generatedAt
      __typename
    }
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetIntroParagraphQueryVariables,
  APITypes.GetIntroParagraphQuery
>;
export const listIntroParagraphs = /* GraphQL */ `query ListIntroParagraphs(
  $filter: ModelIntroParagraphFilterInput
  $limit: Int
  $nextToken: String
) {
  listIntroParagraphs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
        __typename
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIntroParagraphsQueryVariables,
  APITypes.ListIntroParagraphsQuery
>;
export const introParagraphsByAppointmentRecordID = /* GraphQL */ `query IntroParagraphsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIntroParagraphFilterInput
  $limit: Int
  $nextToken: String
) {
  introParagraphsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
        __typename
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IntroParagraphsByAppointmentRecordIDQueryVariables,
  APITypes.IntroParagraphsByAppointmentRecordIDQuery
>;
export const getIntroductionStatement = /* GraphQL */ `query GetIntroductionStatement($id: ID!) {
  getIntroductionStatement(id: $id) {
    id
    appointmentRecordID
    kind
    text
    lastEditedAt
    lastEditedBy
    selectedCoverLetterFileID
    selectionConfirmedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetIntroductionStatementQueryVariables,
  APITypes.GetIntroductionStatementQuery
>;
export const listIntroductionStatements = /* GraphQL */ `query ListIntroductionStatements(
  $filter: ModelIntroductionStatementFilterInput
  $limit: Int
  $nextToken: String
) {
  listIntroductionStatements(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      kind
      text
      lastEditedAt
      lastEditedBy
      selectedCoverLetterFileID
      selectionConfirmedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIntroductionStatementsQueryVariables,
  APITypes.ListIntroductionStatementsQuery
>;
export const introductionStatementsByAppointmentRecordID = /* GraphQL */ `query IntroductionStatementsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIntroductionStatementFilterInput
  $limit: Int
  $nextToken: String
) {
  introductionStatementsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      kind
      text
      lastEditedAt
      lastEditedBy
      selectedCoverLetterFileID
      selectionConfirmedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IntroductionStatementsByAppointmentRecordIDQueryVariables,
  APITypes.IntroductionStatementsByAppointmentRecordIDQuery
>;
export const getAssessment = /* GraphQL */ `query GetAssessment($id: ID!) {
  getAssessment(id: $id) {
    id
    injuries {
      injuryType
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      dateOfInjuryEnd
      dateOfInjuryEndFlexible {
        value
        precision
        __typename
      }
      bodyParts
      causeOfInjury
      causedByWork
      causedByWorkExplanation
      __typename
    }
    discussedBodyParts
    bodyPartsNotDiscussedReason
    discussions
    diagnoses {
      diagnosis
      icdCode
      evidenceSources
      evidence
      __typename
    }
    bodyPartMMIStatus {
      discussByBodyPart
      allBodyPartsMMI {
        mmi
        mmiReason
        expectedMMITimeRange
        expectedMMITimeRangeExplanation
        treatments
        treatmentsExplanation
        discussions
        impairmentRating
        impairmentRatingNotApplicable
        deferImpairmentRating
        deferImpairmentRatingReason
        apportionment
        apportionmentNotApplicable
        deferApportionment
        deferApportionmentReason
        __typename
      }
      bodyPartMMIStatuses {
        bodyPart
        evaluation {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        __typename
      }
      __typename
    }
    workStatus
    markedAsDone
    discussDiagnosesFreeForm
    diagnosesFreeform
    discussCausationFreeForm
    causationFreeForm
    discussMMIImpairmentRatingApportionmentFreeForm
    hasPatientReachedMMIFreeForm
    discussMMIByBodyPartFreeForm
    impairmentRatingByBodyPartFreeForm
    apportionmentByBodyPartFreeForm
    impairmentRatingOtherComments
    apportionmentOtherComments
    assessmentMode
    assessmentFreeForm {
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussions
      diagnosesAndEvidence
      causation
      hasPatientReachedMMI
      discussMMIByBodyPart
      impairmentRatingByBodyPart
      apportionmentByBodyPart
      workStatus
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentQueryVariables,
  APITypes.GetAssessmentQuery
>;
export const listAssessments = /* GraphQL */ `query ListAssessments(
  $id: ID
  $filter: ModelAssessmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAssessments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussedBodyParts
      bodyPartsNotDiscussedReason
      discussions
      diagnoses {
        diagnosis
        icdCode
        evidenceSources
        evidence
        __typename
      }
      bodyPartMMIStatus {
        discussByBodyPart
        allBodyPartsMMI {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        bodyPartMMIStatuses {
          bodyPart
          __typename
        }
        __typename
      }
      workStatus
      markedAsDone
      discussDiagnosesFreeForm
      diagnosesFreeform
      discussCausationFreeForm
      causationFreeForm
      discussMMIImpairmentRatingApportionmentFreeForm
      hasPatientReachedMMIFreeForm
      discussMMIByBodyPartFreeForm
      impairmentRatingByBodyPartFreeForm
      apportionmentByBodyPartFreeForm
      impairmentRatingOtherComments
      apportionmentOtherComments
      assessmentMode
      assessmentFreeForm {
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussions
        diagnosesAndEvidence
        causation
        hasPatientReachedMMI
        discussMMIByBodyPart
        impairmentRatingByBodyPart
        apportionmentByBodyPart
        workStatus
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentsQueryVariables,
  APITypes.ListAssessmentsQuery
>;
export const getValidationCheck = /* GraphQL */ `query GetValidationCheck($id: ID!) {
  getValidationCheck(id: $id) {
    id
    validationID
    checkType
    inputResourceURIs
    status
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetValidationCheckQueryVariables,
  APITypes.GetValidationCheckQuery
>;
export const listValidationChecks = /* GraphQL */ `query ListValidationChecks(
  $id: ID
  $filter: ModelValidationCheckFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listValidationChecks(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      validationID
      checkType
      inputResourceURIs
      status
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListValidationChecksQueryVariables,
  APITypes.ListValidationChecksQuery
>;
export const validationChecksByValidationID = /* GraphQL */ `query ValidationChecksByValidationID(
  $validationID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelValidationCheckFilterInput
  $limit: Int
  $nextToken: String
) {
  validationChecksByValidationID(
    validationID: $validationID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      validationID
      checkType
      inputResourceURIs
      status
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidationChecksByValidationIDQueryVariables,
  APITypes.ValidationChecksByValidationIDQuery
>;
export const getValidationIssue = /* GraphQL */ `query GetValidationIssue($id: ID!) {
  getValidationIssue(id: $id) {
    id
    validationID
    validationCheckID
    title
    issue
    status
    resourceURI
    issueGroup
    issueType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetValidationIssueQueryVariables,
  APITypes.GetValidationIssueQuery
>;
export const listValidationIssues = /* GraphQL */ `query ListValidationIssues(
  $id: ID
  $filter: ModelValidationIssueFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listValidationIssues(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      validationID
      validationCheckID
      title
      issue
      status
      resourceURI
      issueGroup
      issueType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListValidationIssuesQueryVariables,
  APITypes.ListValidationIssuesQuery
>;
export const validationIssuesByValidationID = /* GraphQL */ `query ValidationIssuesByValidationID(
  $validationID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelValidationIssueFilterInput
  $limit: Int
  $nextToken: String
) {
  validationIssuesByValidationID(
    validationID: $validationID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      validationID
      validationCheckID
      title
      issue
      status
      resourceURI
      issueGroup
      issueType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidationIssuesByValidationIDQueryVariables,
  APITypes.ValidationIssuesByValidationIDQuery
>;
export const validationIssuesByValidationCheckID = /* GraphQL */ `query ValidationIssuesByValidationCheckID(
  $validationCheckID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelValidationIssueFilterInput
  $limit: Int
  $nextToken: String
) {
  validationIssuesByValidationCheckID(
    validationCheckID: $validationCheckID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      validationID
      validationCheckID
      title
      issue
      status
      resourceURI
      issueGroup
      issueType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidationIssuesByValidationCheckIDQueryVariables,
  APITypes.ValidationIssuesByValidationCheckIDQuery
>;
export const validationIssuesByResourceURI = /* GraphQL */ `query ValidationIssuesByResourceURI(
  $resourceURI: String!
  $sortDirection: ModelSortDirection
  $filter: ModelValidationIssueFilterInput
  $limit: Int
  $nextToken: String
) {
  validationIssuesByResourceURI(
    resourceURI: $resourceURI
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      validationID
      validationCheckID
      title
      issue
      status
      resourceURI
      issueGroup
      issueType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidationIssuesByResourceURIQueryVariables,
  APITypes.ValidationIssuesByResourceURIQuery
>;
export const getValidation = /* GraphQL */ `query GetValidation($id: ID!) {
  getValidation(id: $id) {
    id
    issueGroups
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetValidationQueryVariables,
  APITypes.GetValidationQuery
>;
export const listValidations = /* GraphQL */ `query ListValidations(
  $id: ID
  $filter: ModelValidationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listValidations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListValidationsQueryVariables,
  APITypes.ListValidationsQuery
>;
export const getWorkflowAuditEntry = /* GraphQL */ `query GetWorkflowAuditEntry($id: ID!) {
  getWorkflowAuditEntry(id: $id) {
    id
    workflowAuditID
    message
    actorType
    actorID
    entryType
    attachments {
      bucket
      key
      __typename
    }
    relatedActionIDs
    payload
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkflowAuditEntryQueryVariables,
  APITypes.GetWorkflowAuditEntryQuery
>;
export const listWorkflowAuditEntries = /* GraphQL */ `query ListWorkflowAuditEntries(
  $id: ID
  $filter: ModelWorkflowAuditEntryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkflowAuditEntries(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      workflowAuditID
      message
      actorType
      actorID
      entryType
      attachments {
        bucket
        key
        __typename
      }
      relatedActionIDs
      payload
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkflowAuditEntriesQueryVariables,
  APITypes.ListWorkflowAuditEntriesQuery
>;
export const workflowAuditEntriesByWorkflowAuditID = /* GraphQL */ `query WorkflowAuditEntriesByWorkflowAuditID(
  $workflowAuditID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWorkflowAuditEntryFilterInput
  $limit: Int
  $nextToken: String
) {
  workflowAuditEntriesByWorkflowAuditID(
    workflowAuditID: $workflowAuditID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workflowAuditID
      message
      actorType
      actorID
      entryType
      attachments {
        bucket
        key
        __typename
      }
      relatedActionIDs
      payload
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WorkflowAuditEntriesByWorkflowAuditIDQueryVariables,
  APITypes.WorkflowAuditEntriesByWorkflowAuditIDQuery
>;
export const getWorkflowAudit = /* GraphQL */ `query GetWorkflowAudit($id: ID!) {
  getWorkflowAudit(id: $id) {
    id
    workflowType
    entityID
    entityType
    appointmentID
    entries {
      items {
        id
        workflowAuditID
        message
        actorType
        actorID
        entryType
        attachments {
          bucket
          key
          __typename
        }
        relatedActionIDs
        payload
        correlationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkflowAuditQueryVariables,
  APITypes.GetWorkflowAuditQuery
>;
export const listWorkflowAudits = /* GraphQL */ `query ListWorkflowAudits(
  $id: ID
  $filter: ModelWorkflowAuditFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkflowAudits(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      workflowType
      entityID
      entityType
      appointmentID
      entries {
        items {
          id
          workflowAuditID
          message
          actorType
          actorID
          entryType
          relatedActionIDs
          payload
          correlationID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkflowAuditsQueryVariables,
  APITypes.ListWorkflowAuditsQuery
>;
export const workflowAuditsByWorkflowTypeAndEntityTypeAndEntityID = /* GraphQL */ `query WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityID(
  $workflowType: String!
  $entityTypeEntityID: ModelWorkflowAuditByWorkflowTypeCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelWorkflowAuditFilterInput
  $limit: Int
  $nextToken: String
) {
  workflowAuditsByWorkflowTypeAndEntityTypeAndEntityID(
    workflowType: $workflowType
    entityTypeEntityID: $entityTypeEntityID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workflowType
      entityID
      entityType
      appointmentID
      entries {
        items {
          id
          workflowAuditID
          message
          actorType
          actorID
          entryType
          relatedActionIDs
          payload
          correlationID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityIDQueryVariables,
  APITypes.WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityIDQuery
>;
export const workflowAuditsByEntityIDAndEntityType = /* GraphQL */ `query WorkflowAuditsByEntityIDAndEntityType(
  $entityID: ID!
  $entityType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelWorkflowAuditFilterInput
  $limit: Int
  $nextToken: String
) {
  workflowAuditsByEntityIDAndEntityType(
    entityID: $entityID
    entityType: $entityType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workflowType
      entityID
      entityType
      appointmentID
      entries {
        items {
          id
          workflowAuditID
          message
          actorType
          actorID
          entryType
          relatedActionIDs
          payload
          correlationID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WorkflowAuditsByEntityIDAndEntityTypeQueryVariables,
  APITypes.WorkflowAuditsByEntityIDAndEntityTypeQuery
>;
export const workflowAuditsByAppointmentID = /* GraphQL */ `query WorkflowAuditsByAppointmentID(
  $appointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWorkflowAuditFilterInput
  $limit: Int
  $nextToken: String
) {
  workflowAuditsByAppointmentID(
    appointmentID: $appointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workflowType
      entityID
      entityType
      appointmentID
      entries {
        items {
          id
          workflowAuditID
          message
          actorType
          actorID
          entryType
          relatedActionIDs
          payload
          correlationID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WorkflowAuditsByAppointmentIDQueryVariables,
  APITypes.WorkflowAuditsByAppointmentIDQuery
>;
export const getWorkflowAuditAction = /* GraphQL */ `query GetWorkflowAuditAction($id: ID!) {
  getWorkflowAuditAction(id: $id) {
    id
    workflowAuditID
    appointmentID
    actionType
    status
    payload
    rationale
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkflowAuditActionQueryVariables,
  APITypes.GetWorkflowAuditActionQuery
>;
export const listWorkflowAuditActions = /* GraphQL */ `query ListWorkflowAuditActions(
  $id: ID
  $filter: ModelWorkflowAuditActionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkflowAuditActions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      workflowAuditID
      appointmentID
      actionType
      status
      payload
      rationale
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkflowAuditActionsQueryVariables,
  APITypes.ListWorkflowAuditActionsQuery
>;
export const workflowAuditActionsByWorkflowAuditID = /* GraphQL */ `query WorkflowAuditActionsByWorkflowAuditID(
  $workflowAuditID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWorkflowAuditActionFilterInput
  $limit: Int
  $nextToken: String
) {
  workflowAuditActionsByWorkflowAuditID(
    workflowAuditID: $workflowAuditID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workflowAuditID
      appointmentID
      actionType
      status
      payload
      rationale
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WorkflowAuditActionsByWorkflowAuditIDQueryVariables,
  APITypes.WorkflowAuditActionsByWorkflowAuditIDQuery
>;
export const workflowAuditActionsByAppointmentID = /* GraphQL */ `query WorkflowAuditActionsByAppointmentID(
  $appointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWorkflowAuditActionFilterInput
  $limit: Int
  $nextToken: String
) {
  workflowAuditActionsByAppointmentID(
    appointmentID: $appointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workflowAuditID
      appointmentID
      actionType
      status
      payload
      rationale
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WorkflowAuditActionsByAppointmentIDQueryVariables,
  APITypes.WorkflowAuditActionsByAppointmentIDQuery
>;
export const getFormDataDraft = /* GraphQL */ `query GetFormDataDraft($id: ID!, $timestamp: AWSDateTime!) {
  getFormDataDraft(id: $id, timestamp: $timestamp) {
    id
    timestamp
    formType
    appointmentId
    data
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFormDataDraftQueryVariables,
  APITypes.GetFormDataDraftQuery
>;
export const listFormDataDrafts = /* GraphQL */ `query ListFormDataDrafts(
  $id: ID
  $timestamp: ModelStringKeyConditionInput
  $filter: ModelFormDataDraftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFormDataDrafts(
    id: $id
    timestamp: $timestamp
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      timestamp
      formType
      appointmentId
      data
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFormDataDraftsQueryVariables,
  APITypes.ListFormDataDraftsQuery
>;
export const formDataDraftsByAppointmentIdAndTimestamp = /* GraphQL */ `query FormDataDraftsByAppointmentIdAndTimestamp(
  $appointmentId: ID!
  $timestamp: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFormDataDraftFilterInput
  $limit: Int
  $nextToken: String
) {
  formDataDraftsByAppointmentIdAndTimestamp(
    appointmentId: $appointmentId
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      formType
      appointmentId
      data
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FormDataDraftsByAppointmentIdAndTimestampQueryVariables,
  APITypes.FormDataDraftsByAppointmentIdAndTimestampQuery
>;
export const getAuditLog = /* GraphQL */ `query GetAuditLog($id: ID!, $timestamp: AWSDateTime!) {
  getAuditLog(id: $id, timestamp: $timestamp) {
    id
    timestamp
    tableName
    recordId
    action
    ttl
    oldImage
    newImage
    changedFields
    eventID
    eventSource
    approximateCreationDateTime
    modifiedBy
    impersonatedBy
    impersonationSessionId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAuditLogQueryVariables,
  APITypes.GetAuditLogQuery
>;
export const listAuditLogs = /* GraphQL */ `query ListAuditLogs(
  $id: ID
  $timestamp: ModelStringKeyConditionInput
  $filter: ModelAuditLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAuditLogs(
    id: $id
    timestamp: $timestamp
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      timestamp
      tableName
      recordId
      action
      ttl
      oldImage
      newImage
      changedFields
      eventID
      eventSource
      approximateCreationDateTime
      modifiedBy
      impersonatedBy
      impersonationSessionId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAuditLogsQueryVariables,
  APITypes.ListAuditLogsQuery
>;
export const auditLogsByTableNameAndTimestamp = /* GraphQL */ `query AuditLogsByTableNameAndTimestamp(
  $tableName: String!
  $timestamp: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAuditLogFilterInput
  $limit: Int
  $nextToken: String
) {
  auditLogsByTableNameAndTimestamp(
    tableName: $tableName
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      tableName
      recordId
      action
      ttl
      oldImage
      newImage
      changedFields
      eventID
      eventSource
      approximateCreationDateTime
      modifiedBy
      impersonatedBy
      impersonationSessionId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AuditLogsByTableNameAndTimestampQueryVariables,
  APITypes.AuditLogsByTableNameAndTimestampQuery
>;
export const getHistoryValidation = /* GraphQL */ `query GetHistoryValidation($id: ID!) {
  getHistoryValidation(id: $id) {
    id
    appointmentRecordID
    status
    groups {
      id
      title
      status
      issues {
        id
        title
        description
        patientInfoSection
        issueType
        __typename
      }
      __typename
    }
    validatedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHistoryValidationQueryVariables,
  APITypes.GetHistoryValidationQuery
>;
export const listHistoryValidations = /* GraphQL */ `query ListHistoryValidations(
  $id: ID
  $filter: ModelHistoryValidationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listHistoryValidations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      status
      groups {
        id
        title
        status
        issues {
          id
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      validatedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHistoryValidationsQueryVariables,
  APITypes.ListHistoryValidationsQuery
>;
export const historyValidationsByAppointmentRecordID = /* GraphQL */ `query HistoryValidationsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelHistoryValidationFilterInput
  $limit: Int
  $nextToken: String
) {
  historyValidationsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      status
      groups {
        id
        title
        status
        issues {
          id
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      validatedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HistoryValidationsByAppointmentRecordIDQueryVariables,
  APITypes.HistoryValidationsByAppointmentRecordIDQuery
>;
export const getFieldTemplate = /* GraphQL */ `query GetFieldTemplate($id: ID!, $version: Int!) {
  getFieldTemplate(id: $id, version: $version) {
    id
    version
    templateType
    specialty
    doctorId
    latestMarker
    adlFieldSectionMappings {
      ADLFieldSectionID
      ADLFieldIDs
      __typename
    }
    medicalHistoryFieldIDs
    createdAt
    updatedAt
    lastUpdatedBy
    changeDescription
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFieldTemplateQueryVariables,
  APITypes.GetFieldTemplateQuery
>;
export const listFieldTemplates = /* GraphQL */ `query ListFieldTemplates(
  $id: ID
  $version: ModelIntKeyConditionInput
  $filter: ModelFieldTemplateFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFieldTemplates(
    id: $id
    version: $version
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      version
      templateType
      specialty
      doctorId
      latestMarker
      adlFieldSectionMappings {
        ADLFieldSectionID
        ADLFieldIDs
        __typename
      }
      medicalHistoryFieldIDs
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFieldTemplatesQueryVariables,
  APITypes.ListFieldTemplatesQuery
>;
export const fieldTemplatesByTemplateTypeAndVersion = /* GraphQL */ `query FieldTemplatesByTemplateTypeAndVersion(
  $templateType: FieldTemplateType!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFieldTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  fieldTemplatesByTemplateTypeAndVersion(
    templateType: $templateType
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialty
      doctorId
      latestMarker
      adlFieldSectionMappings {
        ADLFieldSectionID
        ADLFieldIDs
        __typename
      }
      medicalHistoryFieldIDs
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FieldTemplatesByTemplateTypeAndVersionQueryVariables,
  APITypes.FieldTemplatesByTemplateTypeAndVersionQuery
>;
export const fieldTemplatesBySpecialtyAndVersion = /* GraphQL */ `query FieldTemplatesBySpecialtyAndVersion(
  $specialty: SpecialtyType!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFieldTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  fieldTemplatesBySpecialtyAndVersion(
    specialty: $specialty
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialty
      doctorId
      latestMarker
      adlFieldSectionMappings {
        ADLFieldSectionID
        ADLFieldIDs
        __typename
      }
      medicalHistoryFieldIDs
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FieldTemplatesBySpecialtyAndVersionQueryVariables,
  APITypes.FieldTemplatesBySpecialtyAndVersionQuery
>;
export const fieldTemplatesByDoctorIdAndVersion = /* GraphQL */ `query FieldTemplatesByDoctorIdAndVersion(
  $doctorId: ID!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFieldTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  fieldTemplatesByDoctorIdAndVersion(
    doctorId: $doctorId
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialty
      doctorId
      latestMarker
      adlFieldSectionMappings {
        ADLFieldSectionID
        ADLFieldIDs
        __typename
      }
      medicalHistoryFieldIDs
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FieldTemplatesByDoctorIdAndVersionQueryVariables,
  APITypes.FieldTemplatesByDoctorIdAndVersionQuery
>;
export const fieldTemplatesByLatestMarker = /* GraphQL */ `query FieldTemplatesByLatestMarker(
  $latestMarker: String!
  $sortDirection: ModelSortDirection
  $filter: ModelFieldTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  fieldTemplatesByLatestMarker(
    latestMarker: $latestMarker
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialty
      doctorId
      latestMarker
      adlFieldSectionMappings {
        ADLFieldSectionID
        ADLFieldIDs
        __typename
      }
      medicalHistoryFieldIDs
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FieldTemplatesByLatestMarkerQueryVariables,
  APITypes.FieldTemplatesByLatestMarkerQuery
>;
export const getPhysicalEvalTemplate = /* GraphQL */ `query GetPhysicalEvalTemplate($id: ID!, $version: Int!) {
  getPhysicalEvalTemplate(id: $id, version: $version) {
    id
    version
    templateType
    specialtyCategoryId
    doctorId
    latestMarker
    exams {
      examID
      name
      bodyParts
      instructions
      sections {
        sectionID
        name
        fieldType
        config {
          minValue
          maxValue
          increment
          allowPlusMinus
          allowPlus
          unit
          freeformInputCount
          laterality
          hasNote
          hasDefault
          hasOtherFindings
          renderStyle
          __typename
        }
        questions {
          questionID
          label
          defaultValue
          defaultValueLeft
          defaultValueRight
          phrasing
          positiveText
          negativeText
          __typename
        }
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    lastUpdatedBy
    changeDescription
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPhysicalEvalTemplateQueryVariables,
  APITypes.GetPhysicalEvalTemplateQuery
>;
export const listPhysicalEvalTemplates = /* GraphQL */ `query ListPhysicalEvalTemplates(
  $id: ID
  $version: ModelIntKeyConditionInput
  $filter: ModelPhysicalEvalTemplateFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPhysicalEvalTemplates(
    id: $id
    version: $version
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      version
      templateType
      specialtyCategoryId
      doctorId
      latestMarker
      exams {
        examID
        name
        bodyParts
        instructions
        sections {
          sectionID
          name
          fieldType
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPhysicalEvalTemplatesQueryVariables,
  APITypes.ListPhysicalEvalTemplatesQuery
>;
export const physicalEvalTemplatesByTemplateTypeAndVersion = /* GraphQL */ `query PhysicalEvalTemplatesByTemplateTypeAndVersion(
  $templateType: PhysicalEvalTemplateType!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPhysicalEvalTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  physicalEvalTemplatesByTemplateTypeAndVersion(
    templateType: $templateType
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialtyCategoryId
      doctorId
      latestMarker
      exams {
        examID
        name
        bodyParts
        instructions
        sections {
          sectionID
          name
          fieldType
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PhysicalEvalTemplatesByTemplateTypeAndVersionQueryVariables,
  APITypes.PhysicalEvalTemplatesByTemplateTypeAndVersionQuery
>;
export const physicalEvalTemplatesBySpecialtyCategoryIdAndVersion = /* GraphQL */ `query PhysicalEvalTemplatesBySpecialtyCategoryIdAndVersion(
  $specialtyCategoryId: ID!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPhysicalEvalTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  physicalEvalTemplatesBySpecialtyCategoryIdAndVersion(
    specialtyCategoryId: $specialtyCategoryId
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialtyCategoryId
      doctorId
      latestMarker
      exams {
        examID
        name
        bodyParts
        instructions
        sections {
          sectionID
          name
          fieldType
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PhysicalEvalTemplatesBySpecialtyCategoryIdAndVersionQueryVariables,
  APITypes.PhysicalEvalTemplatesBySpecialtyCategoryIdAndVersionQuery
>;
export const physicalEvalTemplatesByDoctorIdAndVersion = /* GraphQL */ `query PhysicalEvalTemplatesByDoctorIdAndVersion(
  $doctorId: ID!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPhysicalEvalTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  physicalEvalTemplatesByDoctorIdAndVersion(
    doctorId: $doctorId
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialtyCategoryId
      doctorId
      latestMarker
      exams {
        examID
        name
        bodyParts
        instructions
        sections {
          sectionID
          name
          fieldType
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PhysicalEvalTemplatesByDoctorIdAndVersionQueryVariables,
  APITypes.PhysicalEvalTemplatesByDoctorIdAndVersionQuery
>;
export const physicalEvalTemplatesByLatestMarker = /* GraphQL */ `query PhysicalEvalTemplatesByLatestMarker(
  $latestMarker: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPhysicalEvalTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  physicalEvalTemplatesByLatestMarker(
    latestMarker: $latestMarker
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialtyCategoryId
      doctorId
      latestMarker
      exams {
        examID
        name
        bodyParts
        instructions
        sections {
          sectionID
          name
          fieldType
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PhysicalEvalTemplatesByLatestMarkerQueryVariables,
  APITypes.PhysicalEvalTemplatesByLatestMarkerQuery
>;
export const getZendeskTicket = /* GraphQL */ `query GetZendeskTicket($id: ID!) {
  getZendeskTicket(id: $id) {
    id
    ticketID
    appointmentRecordID
    recipientParty
    isPrimary
    isTextTicket
    claimNumber
    version
    lastSyncedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetZendeskTicketQueryVariables,
  APITypes.GetZendeskTicketQuery
>;
export const listZendeskTickets = /* GraphQL */ `query ListZendeskTickets(
  $id: ID
  $filter: ModelZendeskTicketFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listZendeskTickets(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      ticketID
      appointmentRecordID
      recipientParty
      isPrimary
      isTextTicket
      claimNumber
      version
      lastSyncedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListZendeskTicketsQueryVariables,
  APITypes.ListZendeskTicketsQuery
>;
export const zendeskTicketsByAppointmentRecordID = /* GraphQL */ `query ZendeskTicketsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelZendeskTicketFilterInput
  $limit: Int
  $nextToken: String
) {
  zendeskTicketsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ticketID
      appointmentRecordID
      recipientParty
      isPrimary
      isTextTicket
      claimNumber
      version
      lastSyncedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ZendeskTicketsByAppointmentRecordIDQueryVariables,
  APITypes.ZendeskTicketsByAppointmentRecordIDQuery
>;
export const getScheduledCommunication = /* GraphQL */ `query GetScheduledCommunication($id: ID!) {
  getScheduledCommunication(id: $id) {
    id
    appointmentRecordID
    communicationType
    targetParty
    scheduledDate
    status
    templateParams
    sentAt
    zendeskTicketID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetScheduledCommunicationQueryVariables,
  APITypes.GetScheduledCommunicationQuery
>;
export const listScheduledCommunications = /* GraphQL */ `query ListScheduledCommunications(
  $id: ID
  $filter: ModelScheduledCommunicationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listScheduledCommunications(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      communicationType
      targetParty
      scheduledDate
      status
      templateParams
      sentAt
      zendeskTicketID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScheduledCommunicationsQueryVariables,
  APITypes.ListScheduledCommunicationsQuery
>;
export const scheduledCommunicationsByAppointmentRecordID = /* GraphQL */ `query ScheduledCommunicationsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledCommunicationFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledCommunicationsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      communicationType
      targetParty
      scheduledDate
      status
      templateParams
      sentAt
      zendeskTicketID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledCommunicationsByAppointmentRecordIDQueryVariables,
  APITypes.ScheduledCommunicationsByAppointmentRecordIDQuery
>;
export const scheduledCommunicationsByStatusAndScheduledDate = /* GraphQL */ `query ScheduledCommunicationsByStatusAndScheduledDate(
  $status: CommunicationStatus!
  $scheduledDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledCommunicationFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledCommunicationsByStatusAndScheduledDate(
    status: $status
    scheduledDate: $scheduledDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      communicationType
      targetParty
      scheduledDate
      status
      templateParams
      sentAt
      zendeskTicketID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledCommunicationsByStatusAndScheduledDateQueryVariables,
  APITypes.ScheduledCommunicationsByStatusAndScheduledDateQuery
>;
export const getMedicalRecordPageImageTags = /* GraphQL */ `query GetMedicalRecordPageImageTags($documentID: ID!, $pageNumber: Int!) {
  getMedicalRecordPageImageTags(
    documentID: $documentID
    pageNumber: $pageNumber
  ) {
    documentID
    pageNumber
    createdAt
    updatedAt
    isHandWritten
    lowQualityPage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMedicalRecordPageImageTagsQueryVariables,
  APITypes.GetMedicalRecordPageImageTagsQuery
>;
export const listMedicalRecordPageImageTags = /* GraphQL */ `query ListMedicalRecordPageImageTags(
  $documentID: ID
  $pageNumber: ModelIntKeyConditionInput
  $filter: ModelMedicalRecordPageImageTagsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMedicalRecordPageImageTags(
    documentID: $documentID
    pageNumber: $pageNumber
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      documentID
      pageNumber
      createdAt
      updatedAt
      isHandWritten
      lowQualityPage
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMedicalRecordPageImageTagsQueryVariables,
  APITypes.ListMedicalRecordPageImageTagsQuery
>;
export const getMedicalRecordSegmentRawTextTags = /* GraphQL */ `query GetMedicalRecordSegmentRawTextTags(
  $documentID: ID!
  $startPageNumber: Int!
) {
  getMedicalRecordSegmentRawTextTags(
    documentID: $documentID
    startPageNumber: $startPageNumber
  ) {
    documentID
    startPageNumber
    endPageNumber
    createdAt
    updatedAt
    isWrongPatient
    wrongPatientReasoning
    extractedPatientName
    extractedPatientDob
    extractedPatientSex
    wrongPatientPossibility
    doctorName
    doctorNameDetails
    xrayDetails
    mriDetails
    emgDetails
    ctDetails
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMedicalRecordSegmentRawTextTagsQueryVariables,
  APITypes.GetMedicalRecordSegmentRawTextTagsQuery
>;
export const listMedicalRecordSegmentRawTextTags = /* GraphQL */ `query ListMedicalRecordSegmentRawTextTags(
  $documentID: ID
  $startPageNumber: ModelIntKeyConditionInput
  $filter: ModelMedicalRecordSegmentRawTextTagsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMedicalRecordSegmentRawTextTags(
    documentID: $documentID
    startPageNumber: $startPageNumber
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      documentID
      startPageNumber
      endPageNumber
      createdAt
      updatedAt
      isWrongPatient
      wrongPatientReasoning
      extractedPatientName
      extractedPatientDob
      extractedPatientSex
      wrongPatientPossibility
      doctorName
      doctorNameDetails
      xrayDetails
      mriDetails
      emgDetails
      ctDetails
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMedicalRecordSegmentRawTextTagsQueryVariables,
  APITypes.ListMedicalRecordSegmentRawTextTagsQuery
>;
export const getAppointmentEvent = /* GraphQL */ `query GetAppointmentEvent($id: ID!) {
  getAppointmentEvent(id: $id) {
    id
    appointmentRecordID
    entity
    entityID
    action
    actorType
    actorID
    timestamp
    properties
    source
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAppointmentEventQueryVariables,
  APITypes.GetAppointmentEventQuery
>;
export const listAppointmentEvents = /* GraphQL */ `query ListAppointmentEvents(
  $id: ID
  $filter: ModelAppointmentEventFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAppointmentEvents(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      entity
      entityID
      action
      actorType
      actorID
      timestamp
      properties
      source
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAppointmentEventsQueryVariables,
  APITypes.ListAppointmentEventsQuery
>;
export const appointmentEventsByAppointmentRecordID = /* GraphQL */ `query AppointmentEventsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentEventsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      entity
      entityID
      action
      actorType
      actorID
      timestamp
      properties
      source
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentEventsByAppointmentRecordIDQueryVariables,
  APITypes.AppointmentEventsByAppointmentRecordIDQuery
>;
export const appointmentEventsByEntityAndEntityID = /* GraphQL */ `query AppointmentEventsByEntityAndEntityID(
  $entity: String!
  $entityID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentEventsByEntityAndEntityID(
    entity: $entity
    entityID: $entityID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      entity
      entityID
      action
      actorType
      actorID
      timestamp
      properties
      source
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentEventsByEntityAndEntityIDQueryVariables,
  APITypes.AppointmentEventsByEntityAndEntityIDQuery
>;
export const getAppointmentNotification = /* GraphQL */ `query GetAppointmentNotification($id: ID!) {
  getAppointmentNotification(id: $id) {
    id
    appointmentRecordID
    entityType
    entityID
    notificationType
    channel
    recipientType
    recipientID
    recipientName
    title
    body
    status
    readAt
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAppointmentNotificationQueryVariables,
  APITypes.GetAppointmentNotificationQuery
>;
export const listAppointmentNotifications = /* GraphQL */ `query ListAppointmentNotifications(
  $id: ID
  $filter: ModelAppointmentNotificationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAppointmentNotifications(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      entityType
      entityID
      notificationType
      channel
      recipientType
      recipientID
      recipientName
      title
      body
      status
      readAt
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAppointmentNotificationsQueryVariables,
  APITypes.ListAppointmentNotificationsQuery
>;
export const appointmentNotificationsByAppointmentRecordID = /* GraphQL */ `query AppointmentNotificationsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentNotificationsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      entityType
      entityID
      notificationType
      channel
      recipientType
      recipientID
      recipientName
      title
      body
      status
      readAt
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentNotificationsByAppointmentRecordIDQueryVariables,
  APITypes.AppointmentNotificationsByAppointmentRecordIDQuery
>;
export const appointmentNotificationsByRecipientAndStatus = /* GraphQL */ `query AppointmentNotificationsByRecipientAndStatus(
  $recipientID: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentNotificationsByRecipientAndStatus(
    recipientID: $recipientID
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      entityType
      entityID
      notificationType
      channel
      recipientType
      recipientID
      recipientName
      title
      body
      status
      readAt
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentNotificationsByRecipientAndStatusQueryVariables,
  APITypes.AppointmentNotificationsByRecipientAndStatusQuery
>;
export const getEmailNotificationQueue = /* GraphQL */ `query GetEmailNotificationQueue($id: ID!) {
  getEmailNotificationQueue(id: $id) {
    id
    appointmentRecordID
    notificationType
    recipientID
    status
    emailDeliveryID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmailNotificationQueueQueryVariables,
  APITypes.GetEmailNotificationQueueQuery
>;
export const listEmailNotificationQueues = /* GraphQL */ `query ListEmailNotificationQueues(
  $id: ID
  $filter: ModelEmailNotificationQueueFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEmailNotificationQueues(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentRecordID
      notificationType
      recipientID
      status
      emailDeliveryID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmailNotificationQueuesQueryVariables,
  APITypes.ListEmailNotificationQueuesQuery
>;
export const emailNotificationQueuesByAppointmentRecordID = /* GraphQL */ `query EmailNotificationQueuesByAppointmentRecordID(
  $appointmentRecordID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEmailNotificationQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  emailNotificationQueuesByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      notificationType
      recipientID
      status
      emailDeliveryID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EmailNotificationQueuesByAppointmentRecordIDQueryVariables,
  APITypes.EmailNotificationQueuesByAppointmentRecordIDQuery
>;
export const emailNotificationsByRecipientAndStatus = /* GraphQL */ `query EmailNotificationsByRecipientAndStatus(
  $recipientID: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEmailNotificationQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  emailNotificationsByRecipientAndStatus(
    recipientID: $recipientID
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      notificationType
      recipientID
      status
      emailDeliveryID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EmailNotificationsByRecipientAndStatusQueryVariables,
  APITypes.EmailNotificationsByRecipientAndStatusQuery
>;
export const emailNotificationQueuesByEmailDeliveryID = /* GraphQL */ `query EmailNotificationQueuesByEmailDeliveryID(
  $emailDeliveryID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEmailNotificationQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  emailNotificationQueuesByEmailDeliveryID(
    emailDeliveryID: $emailDeliveryID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      notificationType
      recipientID
      status
      emailDeliveryID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EmailNotificationQueuesByEmailDeliveryIDQueryVariables,
  APITypes.EmailNotificationQueuesByEmailDeliveryIDQuery
>;
export const getEmailDelivery = /* GraphQL */ `query GetEmailDelivery($id: ID!) {
  getEmailDelivery(id: $id) {
    id
    emailType
    recipientID
    recipientEmail
    subject
    body
    htmlBody
    status
    sentAt
    failureReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmailDeliveryQueryVariables,
  APITypes.GetEmailDeliveryQuery
>;
export const listEmailDeliveries = /* GraphQL */ `query ListEmailDeliveries(
  $id: ID
  $filter: ModelEmailDeliveryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEmailDeliveries(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      emailType
      recipientID
      recipientEmail
      subject
      body
      htmlBody
      status
      sentAt
      failureReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmailDeliveriesQueryVariables,
  APITypes.ListEmailDeliveriesQuery
>;
export const emailDeliveriesByEmailTypeAndStatus = /* GraphQL */ `query EmailDeliveriesByEmailTypeAndStatus(
  $emailType: String!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEmailDeliveryFilterInput
  $limit: Int
  $nextToken: String
) {
  emailDeliveriesByEmailTypeAndStatus(
    emailType: $emailType
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      emailType
      recipientID
      recipientEmail
      subject
      body
      htmlBody
      status
      sentAt
      failureReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EmailDeliveriesByEmailTypeAndStatusQueryVariables,
  APITypes.EmailDeliveriesByEmailTypeAndStatusQuery
>;
export const emailDeliveriesByRecipientID = /* GraphQL */ `query EmailDeliveriesByRecipientID(
  $recipientID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEmailDeliveryFilterInput
  $limit: Int
  $nextToken: String
) {
  emailDeliveriesByRecipientID(
    recipientID: $recipientID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      emailType
      recipientID
      recipientEmail
      subject
      body
      htmlBody
      status
      sentAt
      failureReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EmailDeliveriesByRecipientIDQueryVariables,
  APITypes.EmailDeliveriesByRecipientIDQuery
>;
export const getChatbotMessage = /* GraphQL */ `query GetChatbotMessage($userId: ID!, $conversationIdTimestamp: String!) {
  getChatbotMessage(
    userId: $userId
    conversationIdTimestamp: $conversationIdTimestamp
  ) {
    userId
    conversationIdTimestamp
    messageId
    conversationId
    role
    content
    suggestedUserPrompt
    createdAt
    llmInput
    llmProvider
    llmModel
    inputTokens
    outputTokens
    reasoningTokens
    cachedTokens
    totalTokens
    toolsCalled
    toolsSucceeded
    toolsFailed
    ttftMs
    total_latency_ms
    userPaused
    agentTurns
    attachments {
      filename
      contentType
      sizeBytes
      s3Bucket
      s3Key
      slackUrl
      source
      __typename
    }
    dataBlocks
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChatbotMessageQueryVariables,
  APITypes.GetChatbotMessageQuery
>;
export const listChatbotMessages = /* GraphQL */ `query ListChatbotMessages(
  $userId: ID
  $conversationIdTimestamp: ModelStringKeyConditionInput
  $filter: ModelChatbotMessageFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listChatbotMessages(
    userId: $userId
    conversationIdTimestamp: $conversationIdTimestamp
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      userId
      conversationIdTimestamp
      messageId
      conversationId
      role
      content
      suggestedUserPrompt
      createdAt
      llmInput
      llmProvider
      llmModel
      inputTokens
      outputTokens
      reasoningTokens
      cachedTokens
      totalTokens
      toolsCalled
      toolsSucceeded
      toolsFailed
      ttftMs
      total_latency_ms
      userPaused
      agentTurns
      attachments {
        filename
        contentType
        sizeBytes
        s3Bucket
        s3Key
        slackUrl
        source
        __typename
      }
      dataBlocks
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatbotMessagesQueryVariables,
  APITypes.ListChatbotMessagesQuery
>;
export const chatbotMessagesByConversationId = /* GraphQL */ `query ChatbotMessagesByConversationId(
  $conversationId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChatbotMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  chatbotMessagesByConversationId(
    conversationId: $conversationId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      userId
      conversationIdTimestamp
      messageId
      conversationId
      role
      content
      suggestedUserPrompt
      createdAt
      llmInput
      llmProvider
      llmModel
      inputTokens
      outputTokens
      reasoningTokens
      cachedTokens
      totalTokens
      toolsCalled
      toolsSucceeded
      toolsFailed
      ttftMs
      total_latency_ms
      userPaused
      agentTurns
      attachments {
        filename
        contentType
        sizeBytes
        s3Bucket
        s3Key
        slackUrl
        source
        __typename
      }
      dataBlocks
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ChatbotMessagesByConversationIdQueryVariables,
  APITypes.ChatbotMessagesByConversationIdQuery
>;
export const getChatbotConversation = /* GraphQL */ `query GetChatbotConversation($userId: ID!, $conversationId: String!) {
  getChatbotConversation(userId: $userId, conversationId: $conversationId) {
    userId
    conversationId
    createdAt
    updatedAt
    name
    archived
    pausedStreaming
    modelConversationId
    claudeSessionId
    routineId
    routineRunId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChatbotConversationQueryVariables,
  APITypes.GetChatbotConversationQuery
>;
export const listChatbotConversations = /* GraphQL */ `query ListChatbotConversations(
  $userId: ID
  $conversationId: ModelStringKeyConditionInput
  $filter: ModelChatbotConversationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listChatbotConversations(
    userId: $userId
    conversationId: $conversationId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      userId
      conversationId
      createdAt
      updatedAt
      name
      archived
      pausedStreaming
      modelConversationId
      claudeSessionId
      routineId
      routineRunId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatbotConversationsQueryVariables,
  APITypes.ListChatbotConversationsQuery
>;
export const chatbotConversationsByUserUpdatedAt = /* GraphQL */ `query ChatbotConversationsByUserUpdatedAt(
  $userId: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChatbotConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  chatbotConversationsByUserUpdatedAt(
    userId: $userId
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      userId
      conversationId
      createdAt
      updatedAt
      name
      archived
      pausedStreaming
      modelConversationId
      claudeSessionId
      routineId
      routineRunId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ChatbotConversationsByUserUpdatedAtQueryVariables,
  APITypes.ChatbotConversationsByUserUpdatedAtQuery
>;
export const getChatbotMonitoring = /* GraphQL */ `query GetChatbotMonitoring($userId: ID!) {
  getChatbotMonitoring(userId: $userId) {
    userId
    totalTokens
    lastWeekTokens
    totalConversations
    totalToolsCalled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChatbotMonitoringQueryVariables,
  APITypes.GetChatbotMonitoringQuery
>;
export const listChatbotMonitorings = /* GraphQL */ `query ListChatbotMonitorings(
  $userId: ID
  $filter: ModelChatbotMonitoringFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listChatbotMonitorings(
    userId: $userId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      userId
      totalTokens
      lastWeekTokens
      totalConversations
      totalToolsCalled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatbotMonitoringsQueryVariables,
  APITypes.ListChatbotMonitoringsQuery
>;
export const getSlackAgentInvocation = /* GraphQL */ `query GetSlackAgentInvocation(
  $slackUserEmail: String!
  $timestamp: AWSDateTime!
) {
  getSlackAgentInvocation(
    slackUserEmail: $slackUserEmail
    timestamp: $timestamp
  ) {
    slackUserEmail
    timestamp
    channel
    threadTs
    eventId
    slackUserId
    slackUserName
    userMessage
    assistantResponse
    inputTokens
    outputTokens
    reasoningTokens
    cachedTokens
    totalTokens
    toolsCalled
    toolsSucceeded
    toolsFailed
    ttftMs
    totalLatencyMs
    agentTurns
    status
    errorMessage
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSlackAgentInvocationQueryVariables,
  APITypes.GetSlackAgentInvocationQuery
>;
export const listSlackAgentInvocations = /* GraphQL */ `query ListSlackAgentInvocations(
  $slackUserEmail: String
  $timestamp: ModelStringKeyConditionInput
  $filter: ModelSlackAgentInvocationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSlackAgentInvocations(
    slackUserEmail: $slackUserEmail
    timestamp: $timestamp
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      slackUserEmail
      timestamp
      channel
      threadTs
      eventId
      slackUserId
      slackUserName
      userMessage
      assistantResponse
      inputTokens
      outputTokens
      reasoningTokens
      cachedTokens
      totalTokens
      toolsCalled
      toolsSucceeded
      toolsFailed
      ttftMs
      totalLatencyMs
      agentTurns
      status
      errorMessage
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSlackAgentInvocationsQueryVariables,
  APITypes.ListSlackAgentInvocationsQuery
>;
export const slackAgentInvocationsByChannel = /* GraphQL */ `query SlackAgentInvocationsByChannel(
  $channel: String!
  $timestamp: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSlackAgentInvocationFilterInput
  $limit: Int
  $nextToken: String
) {
  slackAgentInvocationsByChannel(
    channel: $channel
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      slackUserEmail
      timestamp
      channel
      threadTs
      eventId
      slackUserId
      slackUserName
      userMessage
      assistantResponse
      inputTokens
      outputTokens
      reasoningTokens
      cachedTokens
      totalTokens
      toolsCalled
      toolsSucceeded
      toolsFailed
      ttftMs
      totalLatencyMs
      agentTurns
      status
      errorMessage
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SlackAgentInvocationsByChannelQueryVariables,
  APITypes.SlackAgentInvocationsByChannelQuery
>;
export const getPromptExecution = /* GraphQL */ `query GetPromptExecution($id: ID!) {
  getPromptExecution(id: $id) {
    id
    promptId
    attachments {
      blob {
        bucket
        key
        __typename
      }
      caption
      __typename
    }
    input {
      bucket
      key
      __typename
    }
    output {
      bucket
      key
      __typename
    }
    toolCalls {
      bucket
      key
      __typename
    }
    reasoningSummary
    executedAt
    appointmentID
    entityType
    entityId
    promptHash
    apiHash
    modelName
    modelConfig
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPromptExecutionQueryVariables,
  APITypes.GetPromptExecutionQuery
>;
export const listPromptExecutions = /* GraphQL */ `query ListPromptExecutions(
  $id: ID
  $filter: ModelPromptExecutionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPromptExecutions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      promptId
      attachments {
        blob {
          bucket
          key
          __typename
        }
        caption
        __typename
      }
      input {
        bucket
        key
        __typename
      }
      output {
        bucket
        key
        __typename
      }
      toolCalls {
        bucket
        key
        __typename
      }
      reasoningSummary
      executedAt
      appointmentID
      entityType
      entityId
      promptHash
      apiHash
      modelName
      modelConfig
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPromptExecutionsQueryVariables,
  APITypes.ListPromptExecutionsQuery
>;
export const promptExecutionsByPromptId = /* GraphQL */ `query PromptExecutionsByPromptId(
  $promptId: String!
  $executedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromptExecutionFilterInput
  $limit: Int
  $nextToken: String
) {
  promptExecutionsByPromptId(
    promptId: $promptId
    executedAt: $executedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promptId
      attachments {
        blob {
          bucket
          key
          __typename
        }
        caption
        __typename
      }
      input {
        bucket
        key
        __typename
      }
      output {
        bucket
        key
        __typename
      }
      toolCalls {
        bucket
        key
        __typename
      }
      reasoningSummary
      executedAt
      appointmentID
      entityType
      entityId
      promptHash
      apiHash
      modelName
      modelConfig
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromptExecutionsByPromptIdQueryVariables,
  APITypes.PromptExecutionsByPromptIdQuery
>;
export const promptExecutionsByAppointment = /* GraphQL */ `query PromptExecutionsByAppointment(
  $appointmentID: ID!
  $executedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromptExecutionFilterInput
  $limit: Int
  $nextToken: String
) {
  promptExecutionsByAppointment(
    appointmentID: $appointmentID
    executedAt: $executedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promptId
      attachments {
        blob {
          bucket
          key
          __typename
        }
        caption
        __typename
      }
      input {
        bucket
        key
        __typename
      }
      output {
        bucket
        key
        __typename
      }
      toolCalls {
        bucket
        key
        __typename
      }
      reasoningSummary
      executedAt
      appointmentID
      entityType
      entityId
      promptHash
      apiHash
      modelName
      modelConfig
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromptExecutionsByAppointmentQueryVariables,
  APITypes.PromptExecutionsByAppointmentQuery
>;
export const promptExecutionsByCorrelationID = /* GraphQL */ `query PromptExecutionsByCorrelationID(
  $correlationID: String!
  $executedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromptExecutionFilterInput
  $limit: Int
  $nextToken: String
) {
  promptExecutionsByCorrelationID(
    correlationID: $correlationID
    executedAt: $executedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promptId
      attachments {
        blob {
          bucket
          key
          __typename
        }
        caption
        __typename
      }
      input {
        bucket
        key
        __typename
      }
      output {
        bucket
        key
        __typename
      }
      toolCalls {
        bucket
        key
        __typename
      }
      reasoningSummary
      executedAt
      appointmentID
      entityType
      entityId
      promptHash
      apiHash
      modelName
      modelConfig
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromptExecutionsByCorrelationIDQueryVariables,
  APITypes.PromptExecutionsByCorrelationIDQuery
>;
export const getAppointmentEntityCorrelation = /* GraphQL */ `query GetAppointmentEntityCorrelation($id: ID!) {
  getAppointmentEntityCorrelation(id: $id) {
    id
    appointmentID
    entityType
    entityID
    properties
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAppointmentEntityCorrelationQueryVariables,
  APITypes.GetAppointmentEntityCorrelationQuery
>;
export const listAppointmentEntityCorrelations = /* GraphQL */ `query ListAppointmentEntityCorrelations(
  $id: ID
  $filter: ModelAppointmentEntityCorrelationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAppointmentEntityCorrelations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      appointmentID
      entityType
      entityID
      properties
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAppointmentEntityCorrelationsQueryVariables,
  APITypes.ListAppointmentEntityCorrelationsQuery
>;
export const entityCorrelationsByAppointment = /* GraphQL */ `query EntityCorrelationsByAppointment(
  $appointmentID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentEntityCorrelationFilterInput
  $limit: Int
  $nextToken: String
) {
  entityCorrelationsByAppointment(
    appointmentID: $appointmentID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      entityType
      entityID
      properties
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EntityCorrelationsByAppointmentQueryVariables,
  APITypes.EntityCorrelationsByAppointmentQuery
>;
export const entityCorrelationsByCorrelationID = /* GraphQL */ `query EntityCorrelationsByCorrelationID(
  $correlationID: String!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentEntityCorrelationFilterInput
  $limit: Int
  $nextToken: String
) {
  entityCorrelationsByCorrelationID(
    correlationID: $correlationID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentID
      entityType
      entityID
      properties
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EntityCorrelationsByCorrelationIDQueryVariables,
  APITypes.EntityCorrelationsByCorrelationIDQuery
>;
export const getPromptFeedback = /* GraphQL */ `query GetPromptFeedback($id: ID!) {
  getPromptFeedback(id: $id) {
    id
    promptId
    promptExecutionId
    feedback
    feedbackSource
    actorType
    actorID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPromptFeedbackQueryVariables,
  APITypes.GetPromptFeedbackQuery
>;
export const listPromptFeedbacks = /* GraphQL */ `query ListPromptFeedbacks(
  $id: ID
  $filter: ModelPromptFeedbackFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPromptFeedbacks(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      promptId
      promptExecutionId
      feedback
      feedbackSource
      actorType
      actorID
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPromptFeedbacksQueryVariables,
  APITypes.ListPromptFeedbacksQuery
>;
export const promptFeedbackByPromptId = /* GraphQL */ `query PromptFeedbackByPromptId(
  $promptId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPromptFeedbackFilterInput
  $limit: Int
  $nextToken: String
) {
  promptFeedbackByPromptId(
    promptId: $promptId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promptId
      promptExecutionId
      feedback
      feedbackSource
      actorType
      actorID
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromptFeedbackByPromptIdQueryVariables,
  APITypes.PromptFeedbackByPromptIdQuery
>;
export const getPromptOfflineEvalCase = /* GraphQL */ `query GetPromptOfflineEvalCase($id: ID!) {
  getPromptOfflineEvalCase(id: $id) {
    id
    promptId
    sourcePromptExecutionId
    apiHash
    attachments {
      blob {
        bucket
        key
        __typename
      }
      caption
      __typename
    }
    input {
      bucket
      key
      __typename
    }
    output {
      bucket
      key
      __typename
    }
    toolCalls {
      bucket
      key
      __typename
    }
    description
    verified
    tags
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPromptOfflineEvalCaseQueryVariables,
  APITypes.GetPromptOfflineEvalCaseQuery
>;
export const listPromptOfflineEvalCases = /* GraphQL */ `query ListPromptOfflineEvalCases(
  $id: ID
  $filter: ModelPromptOfflineEvalCaseFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPromptOfflineEvalCases(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      promptId
      sourcePromptExecutionId
      apiHash
      attachments {
        blob {
          bucket
          key
          __typename
        }
        caption
        __typename
      }
      input {
        bucket
        key
        __typename
      }
      output {
        bucket
        key
        __typename
      }
      toolCalls {
        bucket
        key
        __typename
      }
      description
      verified
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPromptOfflineEvalCasesQueryVariables,
  APITypes.ListPromptOfflineEvalCasesQuery
>;
export const offlineEvalCasesByPromptIdAndApiHash = /* GraphQL */ `query OfflineEvalCasesByPromptIdAndApiHash(
  $promptId: String!
  $apiHash: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromptOfflineEvalCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  offlineEvalCasesByPromptIdAndApiHash(
    promptId: $promptId
    apiHash: $apiHash
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promptId
      sourcePromptExecutionId
      apiHash
      attachments {
        blob {
          bucket
          key
          __typename
        }
        caption
        __typename
      }
      input {
        bucket
        key
        __typename
      }
      output {
        bucket
        key
        __typename
      }
      toolCalls {
        bucket
        key
        __typename
      }
      description
      verified
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OfflineEvalCasesByPromptIdAndApiHashQueryVariables,
  APITypes.OfflineEvalCasesByPromptIdAndApiHashQuery
>;
export const getPromptExecutionCounter = /* GraphQL */ `query GetPromptExecutionCounter($id: ID!) {
  getPromptExecutionCounter(id: $id) {
    id
    execCount
    imageCount
    totalBytes
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPromptExecutionCounterQueryVariables,
  APITypes.GetPromptExecutionCounterQuery
>;
export const listPromptExecutionCounters = /* GraphQL */ `query ListPromptExecutionCounters(
  $id: ID
  $filter: ModelPromptExecutionCounterFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPromptExecutionCounters(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      execCount
      imageCount
      totalBytes
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPromptExecutionCountersQueryVariables,
  APITypes.ListPromptExecutionCountersQuery
>;
export const getSkill = /* GraphQL */ `query GetSkill($id: ID!) {
  getSkill(id: $id) {
    id
    name
    description
    body
    scope
    ownerUserId
    roles
    inputs {
      name
      description
      required
      __typename
    }
    visibility
    version
    archivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetSkillQueryVariables, APITypes.GetSkillQuery>;
export const listSkills = /* GraphQL */ `query ListSkills(
  $filter: ModelSkillFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      body
      scope
      ownerUserId
      roles
      inputs {
        name
        description
        required
        __typename
      }
      visibility
      version
      archivedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillsQueryVariables,
  APITypes.ListSkillsQuery
>;
export const skillsByName = /* GraphQL */ `query SkillsByName(
  $name: String!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillFilterInput
  $limit: Int
  $nextToken: String
) {
  skillsByName(
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      body
      scope
      ownerUserId
      roles
      inputs {
        name
        description
        required
        __typename
      }
      visibility
      version
      archivedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillsByNameQueryVariables,
  APITypes.SkillsByNameQuery
>;
export const getRoutine = /* GraphQL */ `query GetRoutine($id: ID!) {
  getRoutine(id: $id) {
    id
    scope
    name
    description
    promptBody
    model
    reasoningEffort
    enableWebSearch
    maxAgentTurns
    conversationMode
    schedule {
      frequency
      intervalHours
      timeOfDay
      weekdays
      runAt
      __typename
    }
    timezone
    enabled
    notifyOwner
    slackChannel
    ownerUserId
    createdAt
    createdVia
    version
    archivedAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRoutineQueryVariables,
  APITypes.GetRoutineQuery
>;
export const listRoutines = /* GraphQL */ `query ListRoutines(
  $filter: ModelRoutineFilterInput
  $limit: Int
  $nextToken: String
) {
  listRoutines(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      scope
      name
      description
      promptBody
      model
      reasoningEffort
      enableWebSearch
      maxAgentTurns
      conversationMode
      schedule {
        frequency
        intervalHours
        timeOfDay
        weekdays
        runAt
        __typename
      }
      timezone
      enabled
      notifyOwner
      slackChannel
      ownerUserId
      createdAt
      createdVia
      version
      archivedAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRoutinesQueryVariables,
  APITypes.ListRoutinesQuery
>;
export const routinesByScope = /* GraphQL */ `query RoutinesByScope(
  $scope: RoutineScope!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRoutineFilterInput
  $limit: Int
  $nextToken: String
) {
  routinesByScope(
    scope: $scope
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scope
      name
      description
      promptBody
      model
      reasoningEffort
      enableWebSearch
      maxAgentTurns
      conversationMode
      schedule {
        frequency
        intervalHours
        timeOfDay
        weekdays
        runAt
        __typename
      }
      timezone
      enabled
      notifyOwner
      slackChannel
      ownerUserId
      createdAt
      createdVia
      version
      archivedAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RoutinesByScopeQueryVariables,
  APITypes.RoutinesByScopeQuery
>;
export const routinesByOwner = /* GraphQL */ `query RoutinesByOwner(
  $ownerUserId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRoutineFilterInput
  $limit: Int
  $nextToken: String
) {
  routinesByOwner(
    ownerUserId: $ownerUserId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scope
      name
      description
      promptBody
      model
      reasoningEffort
      enableWebSearch
      maxAgentTurns
      conversationMode
      schedule {
        frequency
        intervalHours
        timeOfDay
        weekdays
        runAt
        __typename
      }
      timezone
      enabled
      notifyOwner
      slackChannel
      ownerUserId
      createdAt
      createdVia
      version
      archivedAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RoutinesByOwnerQueryVariables,
  APITypes.RoutinesByOwnerQuery
>;
export const getRoutineState = /* GraphQL */ `query GetRoutineState($id: ID!) {
  getRoutineState(id: $id) {
    id
    scope
    ownerUserId
    definitionVersion
    schedulePartition
    nextRunAt
    currentConversationId
    activeRunId
    lastRunId
    consecutiveFailures
    endedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRoutineStateQueryVariables,
  APITypes.GetRoutineStateQuery
>;
export const listRoutineStates = /* GraphQL */ `query ListRoutineStates(
  $filter: ModelRoutineStateFilterInput
  $limit: Int
  $nextToken: String
) {
  listRoutineStates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      scope
      ownerUserId
      definitionVersion
      schedulePartition
      nextRunAt
      currentConversationId
      activeRunId
      lastRunId
      consecutiveFailures
      endedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRoutineStatesQueryVariables,
  APITypes.ListRoutineStatesQuery
>;
export const routineStatesBySchedule = /* GraphQL */ `query RoutineStatesBySchedule(
  $schedulePartition: String!
  $nextRunAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRoutineStateFilterInput
  $limit: Int
  $nextToken: String
) {
  routineStatesBySchedule(
    schedulePartition: $schedulePartition
    nextRunAt: $nextRunAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scope
      ownerUserId
      definitionVersion
      schedulePartition
      nextRunAt
      currentConversationId
      activeRunId
      lastRunId
      consecutiveFailures
      endedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RoutineStatesByScheduleQueryVariables,
  APITypes.RoutineStatesByScheduleQuery
>;
export const getRoutineRun = /* GraphQL */ `query GetRoutineRun($id: ID!) {
  getRoutineRun(id: $id) {
    id
    scope
    routineId
    routineVersion
    createdAt
    definitionSnapshot
    status
    trigger
    triggeredByUserId
    extraContext
    scheduledFor
    startedAt
    finishedAt
    durationMs
    processingStage
    nextProcessingAt
    dispatchAttempts
    lastDispatchedAt
    executionToken
    executionDeadlineAt
    conversationOwnerUserId
    conversationId
    previousConversationId
    userMessageId
    assistantMessageId
    outcome
    headline
    summary
    totalTokens
    agentTurns
    toolsCalled
    toolsFailed
    correlationId
    errorMessage
    ownerDelivery {
      status
      target
      claimToken
      claimExpiresAt
      attemptedAt
      finishedAt
      messageId
      errorMessage
      __typename
    }
    channelDelivery {
      status
      target
      claimToken
      claimExpiresAt
      attemptedAt
      finishedAt
      messageId
      errorMessage
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRoutineRunQueryVariables,
  APITypes.GetRoutineRunQuery
>;
export const listRoutineRuns = /* GraphQL */ `query ListRoutineRuns(
  $filter: ModelRoutineRunFilterInput
  $limit: Int
  $nextToken: String
) {
  listRoutineRuns(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      scope
      routineId
      routineVersion
      createdAt
      definitionSnapshot
      status
      trigger
      triggeredByUserId
      extraContext
      scheduledFor
      startedAt
      finishedAt
      durationMs
      processingStage
      nextProcessingAt
      dispatchAttempts
      lastDispatchedAt
      executionToken
      executionDeadlineAt
      conversationOwnerUserId
      conversationId
      previousConversationId
      userMessageId
      assistantMessageId
      outcome
      headline
      summary
      totalTokens
      agentTurns
      toolsCalled
      toolsFailed
      correlationId
      errorMessage
      ownerDelivery {
        status
        target
        claimToken
        claimExpiresAt
        attemptedAt
        finishedAt
        messageId
        errorMessage
        __typename
      }
      channelDelivery {
        status
        target
        claimToken
        claimExpiresAt
        attemptedAt
        finishedAt
        messageId
        errorMessage
        __typename
      }
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRoutineRunsQueryVariables,
  APITypes.ListRoutineRunsQuery
>;
export const routineRunsByRoutine = /* GraphQL */ `query RoutineRunsByRoutine(
  $routineId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRoutineRunFilterInput
  $limit: Int
  $nextToken: String
) {
  routineRunsByRoutine(
    routineId: $routineId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scope
      routineId
      routineVersion
      createdAt
      definitionSnapshot
      status
      trigger
      triggeredByUserId
      extraContext
      scheduledFor
      startedAt
      finishedAt
      durationMs
      processingStage
      nextProcessingAt
      dispatchAttempts
      lastDispatchedAt
      executionToken
      executionDeadlineAt
      conversationOwnerUserId
      conversationId
      previousConversationId
      userMessageId
      assistantMessageId
      outcome
      headline
      summary
      totalTokens
      agentTurns
      toolsCalled
      toolsFailed
      correlationId
      errorMessage
      ownerDelivery {
        status
        target
        claimToken
        claimExpiresAt
        attemptedAt
        finishedAt
        messageId
        errorMessage
        __typename
      }
      channelDelivery {
        status
        target
        claimToken
        claimExpiresAt
        attemptedAt
        finishedAt
        messageId
        errorMessage
        __typename
      }
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RoutineRunsByRoutineQueryVariables,
  APITypes.RoutineRunsByRoutineQuery
>;
export const routineRunsByWork = /* GraphQL */ `query RoutineRunsByWork(
  $processingStage: String!
  $nextProcessingAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRoutineRunFilterInput
  $limit: Int
  $nextToken: String
) {
  routineRunsByWork(
    processingStage: $processingStage
    nextProcessingAt: $nextProcessingAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scope
      routineId
      routineVersion
      createdAt
      definitionSnapshot
      status
      trigger
      triggeredByUserId
      extraContext
      scheduledFor
      startedAt
      finishedAt
      durationMs
      processingStage
      nextProcessingAt
      dispatchAttempts
      lastDispatchedAt
      executionToken
      executionDeadlineAt
      conversationOwnerUserId
      conversationId
      previousConversationId
      userMessageId
      assistantMessageId
      outcome
      headline
      summary
      totalTokens
      agentTurns
      toolsCalled
      toolsFailed
      correlationId
      errorMessage
      ownerDelivery {
        status
        target
        claimToken
        claimExpiresAt
        attemptedAt
        finishedAt
        messageId
        errorMessage
        __typename
      }
      channelDelivery {
        status
        target
        claimToken
        claimExpiresAt
        attemptedAt
        finishedAt
        messageId
        errorMessage
        __typename
      }
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RoutineRunsByWorkQueryVariables,
  APITypes.RoutineRunsByWorkQuery
>;
export const getDoctorSupportingMA = /* GraphQL */ `query GetDoctorSupportingMA($id: ID!) {
  getDoctorSupportingMA(id: $id) {
    id
    medicalAssistantId
    doctorId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDoctorSupportingMAQueryVariables,
  APITypes.GetDoctorSupportingMAQuery
>;
export const listDoctorSupportingMAS = /* GraphQL */ `query ListDoctorSupportingMAS(
  $filter: ModelDoctorSupportingMAFilterInput
  $limit: Int
  $nextToken: String
) {
  listDoctorSupportingMAS(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      medicalAssistantId
      doctorId
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDoctorSupportingMASQueryVariables,
  APITypes.ListDoctorSupportingMASQuery
>;
export const doctorSupportingMASByMedicalAssistantId = /* GraphQL */ `query DoctorSupportingMASByMedicalAssistantId(
  $medicalAssistantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDoctorSupportingMAFilterInput
  $limit: Int
  $nextToken: String
) {
  doctorSupportingMASByMedicalAssistantId(
    medicalAssistantId: $medicalAssistantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      medicalAssistantId
      doctorId
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DoctorSupportingMASByMedicalAssistantIdQueryVariables,
  APITypes.DoctorSupportingMASByMedicalAssistantIdQuery
>;
export const doctorSupportingMASByDoctorId = /* GraphQL */ `query DoctorSupportingMASByDoctorId(
  $doctorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDoctorSupportingMAFilterInput
  $limit: Int
  $nextToken: String
) {
  doctorSupportingMASByDoctorId(
    doctorId: $doctorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      medicalAssistantId
      doctorId
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DoctorSupportingMASByDoctorIdQueryVariables,
  APITypes.DoctorSupportingMASByDoctorIdQuery
>;
export const getMedicalAssistantSpecialtyCategory = /* GraphQL */ `query GetMedicalAssistantSpecialtyCategory($id: ID!) {
  getMedicalAssistantSpecialtyCategory(id: $id) {
    id
    medicalAssistantId
    specialtyCategoryId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    specialtyCategory {
      id
      name
      specialties
      fallbackMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      medicalAssistants {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      specialtyCategoryFallbackMAId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMedicalAssistantSpecialtyCategoryQueryVariables,
  APITypes.GetMedicalAssistantSpecialtyCategoryQuery
>;
export const listMedicalAssistantSpecialtyCategories = /* GraphQL */ `query ListMedicalAssistantSpecialtyCategories(
  $filter: ModelMedicalAssistantSpecialtyCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listMedicalAssistantSpecialtyCategories(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      medicalAssistantId
      specialtyCategoryId
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      specialtyCategory {
        id
        name
        specialties
        fallbackMA {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        medicalAssistants {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        specialtyCategoryFallbackMAId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMedicalAssistantSpecialtyCategoriesQueryVariables,
  APITypes.ListMedicalAssistantSpecialtyCategoriesQuery
>;
export const medicalAssistantSpecialtyCategoriesByMedicalAssistantId = /* GraphQL */ `query MedicalAssistantSpecialtyCategoriesByMedicalAssistantId(
  $medicalAssistantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMedicalAssistantSpecialtyCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  medicalAssistantSpecialtyCategoriesByMedicalAssistantId(
    medicalAssistantId: $medicalAssistantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      medicalAssistantId
      specialtyCategoryId
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      specialtyCategory {
        id
        name
        specialties
        fallbackMA {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        medicalAssistants {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        specialtyCategoryFallbackMAId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MedicalAssistantSpecialtyCategoriesByMedicalAssistantIdQueryVariables,
  APITypes.MedicalAssistantSpecialtyCategoriesByMedicalAssistantIdQuery
>;
export const medicalAssistantSpecialtyCategoriesBySpecialtyCategoryId = /* GraphQL */ `query MedicalAssistantSpecialtyCategoriesBySpecialtyCategoryId(
  $specialtyCategoryId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMedicalAssistantSpecialtyCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  medicalAssistantSpecialtyCategoriesBySpecialtyCategoryId(
    specialtyCategoryId: $specialtyCategoryId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      medicalAssistantId
      specialtyCategoryId
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      specialtyCategory {
        id
        name
        specialties
        fallbackMA {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        medicalAssistants {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        specialtyCategoryFallbackMAId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MedicalAssistantSpecialtyCategoriesBySpecialtyCategoryIdQueryVariables,
  APITypes.MedicalAssistantSpecialtyCategoriesBySpecialtyCategoryIdQuery
>;
export const getUserAppointmentFilterPreset = /* GraphQL */ `query GetUserAppointmentFilterPreset($id: ID!) {
  getUserAppointmentFilterPreset(id: $id) {
    id
    userId
    appointmentFilterPresetId
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    appointmentFilterPreset {
      id
      name
      filters {
        type
        values
        __typename
      }
      appliesTo
      view
      users {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserAppointmentFilterPresetQueryVariables,
  APITypes.GetUserAppointmentFilterPresetQuery
>;
export const listUserAppointmentFilterPresets = /* GraphQL */ `query ListUserAppointmentFilterPresets(
  $filter: ModelUserAppointmentFilterPresetFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserAppointmentFilterPresets(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      appointmentFilterPresetId
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      appointmentFilterPreset {
        id
        name
        filters {
          type
          values
          __typename
        }
        appliesTo
        view
        users {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserAppointmentFilterPresetsQueryVariables,
  APITypes.ListUserAppointmentFilterPresetsQuery
>;
export const userAppointmentFilterPresetsByUserId = /* GraphQL */ `query UserAppointmentFilterPresetsByUserId(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAppointmentFilterPresetFilterInput
  $limit: Int
  $nextToken: String
) {
  userAppointmentFilterPresetsByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      appointmentFilterPresetId
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      appointmentFilterPreset {
        id
        name
        filters {
          type
          values
          __typename
        }
        appliesTo
        view
        users {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAppointmentFilterPresetsByUserIdQueryVariables,
  APITypes.UserAppointmentFilterPresetsByUserIdQuery
>;
export const userAppointmentFilterPresetsByAppointmentFilterPresetId = /* GraphQL */ `query UserAppointmentFilterPresetsByAppointmentFilterPresetId(
  $appointmentFilterPresetId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAppointmentFilterPresetFilterInput
  $limit: Int
  $nextToken: String
) {
  userAppointmentFilterPresetsByAppointmentFilterPresetId(
    appointmentFilterPresetId: $appointmentFilterPresetId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      appointmentFilterPresetId
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      appointmentFilterPreset {
        id
        name
        filters {
          type
          values
          __typename
        }
        appliesTo
        view
        users {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAppointmentFilterPresetsByAppointmentFilterPresetIdQueryVariables,
  APITypes.UserAppointmentFilterPresetsByAppointmentFilterPresetIdQuery
>;
export const getAppointmentRecordPatientCase = /* GraphQL */ `query GetAppointmentRecordPatientCase($id: ID!) {
  getAppointmentRecordPatientCase(id: $id) {
    id
    appointmentRecordId
    patientCaseId
    appointmentRecord {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    patientCase {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    doctorOwnerCognitoId
    assistantCognitoIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAppointmentRecordPatientCaseQueryVariables,
  APITypes.GetAppointmentRecordPatientCaseQuery
>;
export const listAppointmentRecordPatientCases = /* GraphQL */ `query ListAppointmentRecordPatientCases(
  $filter: ModelAppointmentRecordPatientCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listAppointmentRecordPatientCases(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordId
      patientCaseId
      appointmentRecord {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      patientCase {
        id
        patientID
        patient {
          id
          name
          dateOfBirth
          SSN
          language
          dominantHand
          occupation
          sex
          weightLb
          createdAt
          updatedAt
          __typename
        }
        claimNumber
        qmePanelNumber
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        injuryInfo {
          injuryType
          injuredBodyParts
          claimedBodyParts
          description
          dateOfInjury
          startDateOfInjury
          __typename
        }
        workersCompInsurance {
          insuranceCarrier
          adjuster
          __typename
        }
        insuranceCarrierID
        insuranceCarrier {
          id
          name
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierAddressID
        insuranceCarrierAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierFaxNumberID
        insuranceCarrierFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierPhoneNumberID
        insuranceCarrierPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        applicantAttorney {
          name
          lawFirmName
          __typename
        }
        applicantAttorneyLawFirmID
        applicantAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyAddressID
        applicantAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyFaxNumberID
        applicantAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyPhoneNumberID
        applicantAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorney {
          name
          lawFirmName
          __typename
        }
        defenseAttorneyLawFirmID
        defenseAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyAddressID
        defenseAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyFaxNumberID
        defenseAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyPhoneNumberID
        defenseAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nurseCaseManager {
          name
          organizationName
          __typename
        }
        ccPerson {
          name
          organizationName
          __typename
        }
        applicantAttorneyCcEmails
        defenseAttorneyCcEmails
        adjusterCcEmails
        scheduledCommsSuppressedParties
        employmentAtInjury {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        WCAB
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      doctorOwnerCognitoId
      assistantCognitoIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAppointmentRecordPatientCasesQueryVariables,
  APITypes.ListAppointmentRecordPatientCasesQuery
>;
export const appointmentRecordPatientCasesByAppointmentRecordId = /* GraphQL */ `query AppointmentRecordPatientCasesByAppointmentRecordId(
  $appointmentRecordId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordPatientCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordPatientCasesByAppointmentRecordId(
    appointmentRecordId: $appointmentRecordId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordId
      patientCaseId
      appointmentRecord {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      patientCase {
        id
        patientID
        patient {
          id
          name
          dateOfBirth
          SSN
          language
          dominantHand
          occupation
          sex
          weightLb
          createdAt
          updatedAt
          __typename
        }
        claimNumber
        qmePanelNumber
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        injuryInfo {
          injuryType
          injuredBodyParts
          claimedBodyParts
          description
          dateOfInjury
          startDateOfInjury
          __typename
        }
        workersCompInsurance {
          insuranceCarrier
          adjuster
          __typename
        }
        insuranceCarrierID
        insuranceCarrier {
          id
          name
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierAddressID
        insuranceCarrierAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierFaxNumberID
        insuranceCarrierFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierPhoneNumberID
        insuranceCarrierPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        applicantAttorney {
          name
          lawFirmName
          __typename
        }
        applicantAttorneyLawFirmID
        applicantAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyAddressID
        applicantAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyFaxNumberID
        applicantAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyPhoneNumberID
        applicantAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorney {
          name
          lawFirmName
          __typename
        }
        defenseAttorneyLawFirmID
        defenseAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyAddressID
        defenseAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyFaxNumberID
        defenseAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyPhoneNumberID
        defenseAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nurseCaseManager {
          name
          organizationName
          __typename
        }
        ccPerson {
          name
          organizationName
          __typename
        }
        applicantAttorneyCcEmails
        defenseAttorneyCcEmails
        adjusterCcEmails
        scheduledCommsSuppressedParties
        employmentAtInjury {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        WCAB
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      doctorOwnerCognitoId
      assistantCognitoIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentRecordPatientCasesByAppointmentRecordIdQueryVariables,
  APITypes.AppointmentRecordPatientCasesByAppointmentRecordIdQuery
>;
export const appointmentRecordPatientCasesByPatientCaseId = /* GraphQL */ `query AppointmentRecordPatientCasesByPatientCaseId(
  $patientCaseId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordPatientCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordPatientCasesByPatientCaseId(
    patientCaseId: $patientCaseId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordId
      patientCaseId
      appointmentRecord {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      patientCase {
        id
        patientID
        patient {
          id
          name
          dateOfBirth
          SSN
          language
          dominantHand
          occupation
          sex
          weightLb
          createdAt
          updatedAt
          __typename
        }
        claimNumber
        qmePanelNumber
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        injuryInfo {
          injuryType
          injuredBodyParts
          claimedBodyParts
          description
          dateOfInjury
          startDateOfInjury
          __typename
        }
        workersCompInsurance {
          insuranceCarrier
          adjuster
          __typename
        }
        insuranceCarrierID
        insuranceCarrier {
          id
          name
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierAddressID
        insuranceCarrierAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierFaxNumberID
        insuranceCarrierFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierPhoneNumberID
        insuranceCarrierPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        applicantAttorney {
          name
          lawFirmName
          __typename
        }
        applicantAttorneyLawFirmID
        applicantAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyAddressID
        applicantAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyFaxNumberID
        applicantAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyPhoneNumberID
        applicantAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorney {
          name
          lawFirmName
          __typename
        }
        defenseAttorneyLawFirmID
        defenseAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyAddressID
        defenseAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyFaxNumberID
        defenseAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyPhoneNumberID
        defenseAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nurseCaseManager {
          name
          organizationName
          __typename
        }
        ccPerson {
          name
          organizationName
          __typename
        }
        applicantAttorneyCcEmails
        defenseAttorneyCcEmails
        adjusterCcEmails
        scheduledCommsSuppressedParties
        employmentAtInjury {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        WCAB
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      doctorOwnerCognitoId
      assistantCognitoIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentRecordPatientCasesByPatientCaseIdQueryVariables,
  APITypes.AppointmentRecordPatientCasesByPatientCaseIdQuery
>;
export const getDoctorLocation = /* GraphQL */ `query GetDoctorLocation($id: ID!) {
  getDoctorLocation(id: $id) {
    id
    doctorId
    locationId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDoctorLocationQueryVariables,
  APITypes.GetDoctorLocationQuery
>;
export const listDoctorLocations = /* GraphQL */ `query ListDoctorLocations(
  $filter: ModelDoctorLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listDoctorLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      doctorId
      locationId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDoctorLocationsQueryVariables,
  APITypes.ListDoctorLocationsQuery
>;
export const doctorLocationsByDoctorId = /* GraphQL */ `query DoctorLocationsByDoctorId(
  $doctorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDoctorLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  doctorLocationsByDoctorId(
    doctorId: $doctorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      locationId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DoctorLocationsByDoctorIdQueryVariables,
  APITypes.DoctorLocationsByDoctorIdQuery
>;
export const doctorLocationsByLocationId = /* GraphQL */ `query DoctorLocationsByLocationId(
  $locationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDoctorLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  doctorLocationsByLocationId(
    locationId: $locationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      locationId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DoctorLocationsByLocationIdQueryVariables,
  APITypes.DoctorLocationsByLocationIdQuery
>;
export const getDoctorCaseSummaryField = /* GraphQL */ `query GetDoctorCaseSummaryField($id: ID!) {
  getDoctorCaseSummaryField(id: $id) {
    id
    doctorId
    caseSummaryFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    caseSummaryField {
      id
      name
      default
      description
      summaryPrompt
      doctors {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDoctorCaseSummaryFieldQueryVariables,
  APITypes.GetDoctorCaseSummaryFieldQuery
>;
export const listDoctorCaseSummaryFields = /* GraphQL */ `query ListDoctorCaseSummaryFields(
  $filter: ModelDoctorCaseSummaryFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  listDoctorCaseSummaryFields(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      caseSummaryFieldId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      caseSummaryField {
        id
        name
        default
        description
        summaryPrompt
        doctors {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDoctorCaseSummaryFieldsQueryVariables,
  APITypes.ListDoctorCaseSummaryFieldsQuery
>;
export const doctorCaseSummaryFieldsByDoctorId = /* GraphQL */ `query DoctorCaseSummaryFieldsByDoctorId(
  $doctorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDoctorCaseSummaryFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  doctorCaseSummaryFieldsByDoctorId(
    doctorId: $doctorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      caseSummaryFieldId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      caseSummaryField {
        id
        name
        default
        description
        summaryPrompt
        doctors {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DoctorCaseSummaryFieldsByDoctorIdQueryVariables,
  APITypes.DoctorCaseSummaryFieldsByDoctorIdQuery
>;
export const doctorCaseSummaryFieldsByCaseSummaryFieldId = /* GraphQL */ `query DoctorCaseSummaryFieldsByCaseSummaryFieldId(
  $caseSummaryFieldId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDoctorCaseSummaryFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  doctorCaseSummaryFieldsByCaseSummaryFieldId(
    caseSummaryFieldId: $caseSummaryFieldId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      caseSummaryFieldId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      caseSummaryField {
        id
        name
        default
        description
        summaryPrompt
        doctors {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DoctorCaseSummaryFieldsByCaseSummaryFieldIdQueryVariables,
  APITypes.DoctorCaseSummaryFieldsByCaseSummaryFieldIdQuery
>;
export const getDoctorBriefingField = /* GraphQL */ `query GetDoctorBriefingField($id: ID!) {
  getDoctorBriefingField(id: $id) {
    id
    doctorId
    briefingFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    briefingField {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDoctorBriefingFieldQueryVariables,
  APITypes.GetDoctorBriefingFieldQuery
>;
export const listDoctorBriefingFields = /* GraphQL */ `query ListDoctorBriefingFields(
  $filter: ModelDoctorBriefingFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  listDoctorBriefingFields(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      briefingFieldId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      briefingField {
        id
        name
        default
        description
        briefingPrompt
        doctors {
          nextToken
          __typename
        }
        briefingRecordTypeID
        recordType {
          id
          name
          recordType
          description
          default
          classificationPrompt
          recordBasePrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDoctorBriefingFieldsQueryVariables,
  APITypes.ListDoctorBriefingFieldsQuery
>;
export const doctorBriefingFieldsByDoctorId = /* GraphQL */ `query DoctorBriefingFieldsByDoctorId(
  $doctorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDoctorBriefingFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  doctorBriefingFieldsByDoctorId(
    doctorId: $doctorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      briefingFieldId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      briefingField {
        id
        name
        default
        description
        briefingPrompt
        doctors {
          nextToken
          __typename
        }
        briefingRecordTypeID
        recordType {
          id
          name
          recordType
          description
          default
          classificationPrompt
          recordBasePrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DoctorBriefingFieldsByDoctorIdQueryVariables,
  APITypes.DoctorBriefingFieldsByDoctorIdQuery
>;
export const doctorBriefingFieldsByBriefingFieldId = /* GraphQL */ `query DoctorBriefingFieldsByBriefingFieldId(
  $briefingFieldId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDoctorBriefingFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  doctorBriefingFieldsByBriefingFieldId(
    briefingFieldId: $briefingFieldId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      briefingFieldId
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      briefingField {
        id
        name
        default
        description
        briefingPrompt
        doctors {
          nextToken
          __typename
        }
        briefingRecordTypeID
        recordType {
          id
          name
          recordType
          description
          default
          classificationPrompt
          recordBasePrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      ownerCognitoId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DoctorBriefingFieldsByBriefingFieldIdQueryVariables,
  APITypes.DoctorBriefingFieldsByBriefingFieldIdQuery
>;
export const searchAppointments = /* GraphQL */ `query SearchAppointments($input: AppointmentSearchInput!) {
  searchAppointments(input: $input) {
    items {
      id
      patient_name
      primary_claim_number
      other_claim_numbers
      doctor_name
      location
      doctor_id
      date
      time
      language
      appt_type
      is_prod
      __typename
    }
    total
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchAppointmentsQueryVariables,
  APITypes.SearchAppointmentsQuery
>;
